import React, { useEffect, useState, useRef, useMemo } from "react";
import styled, { keyframes } from "styled-components";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { v4 as uuidv4 } from "uuid";
import { CSSTransition, TransitionGroup } from "react-transition-group"; // new

import {
  SG_START_BRIEF_SURVEY,
  NEW_VALIDATION_TOKEN,
  RESET_VALIDATION_TOKEN,
  CLEAR_ALL,
  SG_POST_BRIEF_RESPONSE,
  // UPDATE_BRIEF_RESPONSE,
  SG_UPDATE_BRIEF_RESPONSE,
  CLEAR_CHAT_GPT_SUMMARY,
  // SG_GET_ALL_MODULAR_QUESTIONS,
} from "constants/actions";
import {
  // BrowserView,

  // MobileView,

  isBrowser,
  isMobile,
  deviceType,
  osName,
  osVersion,
  deviceDetect,
} from "react-device-detect";
import {
  introductionTypeQuestion,
  categoryTypeQuestion,
  questionTypeQuestion,
  feedbackTypeQuestion,
  personalityTypeQuestion,
  modularOutcomeTypeQuestion,
  modularValuesTypeQuestion,
  modularCommentTypeQuestion,

  // commentsType,

  // questionsType,
  ModularSurveyQuestionTypes,
  personalityQuestionList,
  introSectionTypeQuestion,
  followupAiTypeQuestion,
  multiAiFollowupCommentQuestion, // feedback_builder multiAiFollowupCommentQuestion
  modularSelectCommentTypeQuestion,
  completedTypeQuestion,
  submitTypeQuestion,
  commentTypeQuestion,
  submitSurvey,
  nextQuestionBtn,
  introductionBtn,
} from "constants/questionTypes";

import {
  MISSING_OR_INVALID_TOKEN,
  ERROR_ON_SUBMISSION,
  THANKYOU_MESSAGE,
} from "constants/messaging";

import { AuditRunRules } from "utilities/FeedbackRules";

import { ModularSurveyCheck } from "utilities/ModularRules";

import AuditExistingDataFound from "survey/SurveyComponents/AuditExistingData";

// new survey

import Question from "./questionTypes/Question";

import ProgressBar from "./Components/ProgressBar";

import Feedback from "./questionTypes/Feedback";

import Categories from "./questionTypes/Categories";
import CategoryMulti from "./questionTypes/CategoryMulti";

import Introduction from "./Introduction";

import "./index.css";

import NavigationButtons from "./Components/NavigationButtons";

import FollowUp from "./chatGpt/FollowUp";

import MultiFollowUp from "./chatGpt/MultiFollowUp";

import Submit from "./questionTypes/Submit";

import IntroSection from "./IntroSection";

import Completed from "./questionTypes/Completed";

import Language from "./Language";

import Comments from "./questionTypes/Comment";

import QuestionModular from "./questionTypes/QuestionOutcome";

import QuestionComments from "./questionTypes/QuestionComments";

import PersonalityChoice from "./questionTypes/PersonalityChoice";

import QuestionValues from "./questionTypes/QuestionValues";

import CustomIntro from "./questionTypes/CustomIntro";

import SingleSelectFeedback from "./questionTypes/SingleSelectFeedbackV2";

import LogoAnimation from "survey/SurveyComponents/LogoAnimations";

import { words } from "./translations";

import { sort } from "semver";

import { get } from "http";

import buildIntroSequence from "./config/introConfigurations";

import { customIntroTypeQuestion } from "constants/questionTypes";

import EndScreens, { hasEndScreens, normalizeEndScreens } from "./EndScreens";

// const categoryType = "category"

let LOCAL_VALIDATION_TOKEN = localStorage.getItem("validation_token");

// Controls how often to PATCH progress to the server. 1 = every nav (current behavior)
// Set to 5 or 10 to PATCH every 5th or 10th Next/Back action.
const PATCH_EVERY_N = 10;

// Feature flag to disable response migration/hydration if needed
const DISABLE_FEEDBACK_MIGRATION = false;

const arrange_Questions = (questions) => {
  if (questions?.dimensions) {
    return questions.dimensions

      .map((item, i) => {
        return item.factors.map((factor, f) => {
          return factor.questions.map((q, idx) => {
            return {
              question: q.q,

              dimension: i,

              factor: f,

              q: idx,

              role: q.role,

              reverse: q.reverse,

              order: q.id,

              fr: "fr" in q ? q.fr : null,

              es: "es" in q ? q.es : null,

              por: "por" in q ? q.por : null,

              title: questions?.question_titles ? factor.title : false,

              qualifier: q?.qualifier,

              scale: q?.scale,

              allowSkip: q?.allowSkip || questions?.allowSkip,

              variants: q?.variants || null,

              importance: q?.importance || null,

              // propagate follow-up thresholds to each flattened question for downstream rules

              low_follow_up_score: questions?.low_follow_up_score ?? null,

              high_follow_up_score: questions?.high_follow_up_score ?? null,
            };
          });
        });
      })

      .flat()

      .flat()

      .sort((a, b) => a.order - b.order);
  }
};

const hasMatch = (questionRole, employeeCategoryIds) => {
  if (!questionRole || !Array.isArray(employeeCategoryIds)) return false;

  if (Array.isArray(questionRole)) {
    return questionRole.some((roleId) => employeeCategoryIds.includes(roleId));
  }

  return employeeCategoryIds.includes(questionRole);
};

const AuditSurvey = () => {
  const dispatch = useDispatch();

  const deviceDetected = deviceDetect();

  let { token } = useParams();

  // eslint-disable-next-line no-unused-vars

  let [searchParams, setSearchParams] = useSearchParams();

  const direct_language = Number(searchParams.get("language"));

  const [noResponse, setNoResponse] = useState(false);

  // const [loading, setLoading] = useState(true)

  const [ruleFeedback, setRuleFeedback] = useState(false);

  const [orgRules, setOrgRules] = useState(false);

  const [delayedShow, setDelayedShow] = useState(true);

  //

  const [questionSequenceMap, setQuestionSequenceMap] = useState(false);

  const [totalQuestions, setTotalQuestions] = useState({
    total: 0,

    runningTotal: 0,

    questions: 0,

    culture: 0,

    sequence: {},
  });

  const [showingStoredResponse, setShowingStoredResponse] = useState(false);

  const [questionList, setQuestionList] = useState([]);

  const [categoryQues, setCategoryQues] = useState([]);

  const [employeeCategory, setEmployeeCategory] = useState([]);

  const [showLanguage, setShowLanguage] = React.useState(false);

  // Count navigations to throttle PATCH calls
  const patchCounterRef = useRef(0);

  const [languages, setLanguages] = React.useState([]);

  // stored persisting response

  // const [validationToken, setValidationToken] = useState(false)

  const [briefResponseId, setBriefResponseId] = useState(false);

  const [storedResponseFound, setStoredResponseFound] = useState(false);

  //

  const [briefResponse, setBriefResponse] = useState([]);

  const [storedResponse, setStoredResponse] = useState(false);

  const [questionNo, setQuestionNo] = useState(0);

  const [visualQuestionNo, setVisualQuestionNo] = useState(0);

  //

  // const [prevResponse, setPrevResponse] = useState({})

  //

  const [checkRole, setCheckRole] = useState(false);

  const [questionAnswers, setQuestionAnswers] = useState({
    categories: {},

    questions: {},

    comments: {},
  });

  const [formPayload, setFormPayload] = useState(false);

  // const [thankMessage, setThankMessage] = useState(false)

  const [surveyStatus, setSurveyStatus] = useState(0);

  const [surveyDeleted, setSurveyDeleted] = useState(false);

  const [surveyDeletedOn, setSurveyDeletedOn] = useState(false);

  const [primaryCategory, setPrimaryCategory] = useState(false);

  // const [surveyName, setSurveyName] = useState(false)

  const [neverAskResponse, setNeverAskResponse] = useState(false);

  const [prevFoundResponse, setPrevFoundResponse] = useState(false);

  const [organizationName, setOrganizationName] = useState("");

  const [language, setLanguage] = useState("EN");

  const [askComments, setAskComments] = useState(false);

  const [submitError, setSubmitError] = useState(false);

  const [organizationInfo, setOrganizationInfo] = useState(false);

  const [surveyStandards, setSurveyStandards] = useState(false);

  //

  const [surveyFeedbackResp, setSurveyFeedbackResp] = useState(false);

  const [surveyPersonalityResp, setSurveyPersonalityResp] = useState({});

  const [surveyModularResp, setSurveyModularResp] = useState(false);

  // in_survey_personality

  const [showInSurveyPersonality, setShowInSurveyPersonality] = useState(true);

  const [askNextQuestion, setAskNextQuestion] = useState(false);

  //

  const [modSurveyRule, setModSurveyRule] = useState([]);

  // //new

  const [currentQuestionDet, setCurrentQuestionDet] = useState({});

  const [currentQuestionNo, setCurrentQuestionNo] = useState(1);

  const [direction, setDirection] = useState("slide");

  const [isVisible, setIsVisible] = useState(false);

  const [surveyFinished, setSurveyFinished] = useState(false);

  // //new

  const [storedTitle, setStoredTitle] = useState("");

  const [teamName, setTeamName] = useState("");

  const [progressBarColor, setProgressBarColor] = useState("#f5f5f5");

  const [sortOrder, setSortOrder] = useState(0);

  const [disableNext, setDisableNext] = useState(false);

  const [height, setHeight] = useState(window.innerHeight);

  const [totalRows, setTotalRows] = useState(0);

  const [endScreensPersisted, setEndScreensPersisted] = useState([]);

  // Dynamic top bar measurement (must be declared before any early returns)

  const topBarRef = useRef(null);

  const [topBarHeight, setTopBarHeight] = useState(50);

  // Ref for synchronous access to latest question data in NavigationButtons
  const questionSequenceMapRef = useRef(null);

  const { get_brief_response, get_errors } = useSelector(
    (state) => ({
      get_brief_response: state.briefresponse,

      get_errors: state.errors,
    }),

    shallowEqual
  );

  const customHeader = useMemo(() => {
    const raw = get_brief_response?.response?.questions?.custom_headers;
    if (!raw || !raw.image_url) return null;

    const useImage =
      String(raw.use_image_as_qualifier).toLowerCase() === "true";
    if (!useImage) return null;

    const parsedHeight = parseInt(raw.image_height, 10);
    const imageHeight =
      Number.isFinite(parsedHeight) && parsedHeight > 0 ? parsedHeight : 100;

    return {
      imageUrl: raw.image_url,
      imageHeight,
      useImageAsQualifier: useImage,
    };
  }, [get_brief_response?.response?.questions?.custom_headers]);

  useEffect(() => {
    const updateHeight = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", updateHeight);

    // Set the initial height based on viewport

    updateHeight();

    // Cleanup event listener on unmount

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  useEffect(() => {
    if (direct_language === 1) {
      setLanguage("FR");
    }

    if (direct_language === 2) {
      setLanguage("ES");
    }

    if (direct_language === 3) {
      setLanguage("POR");
    }
  }, [direct_language]);

  // useEffect(() => {

  // 	setTimeout(() => {

  // 		setLoading(false)

  // 	}, 1500)

  // }, [])

  useEffect(() => {
    const RuleRun = AuditRunRules(
      questionList,
      orgRules,
      questionAnswers,
      surveyStandards
    );

    setRuleFeedback(RuleRun);
  }, [
    orgRules,

    questionList,

    questionAnswers,

    currentQuestionNo,

    showingStoredResponse,

    surveyStandards,
  ]);

  // Measure TopBar height and propagate to container padding

  useEffect(() => {
    const updateTopBarHeight = () => {
      if (topBarRef.current) {
        setTopBarHeight(topBarRef.current.offsetHeight);
      }
    };

    updateTopBarHeight();

    window.addEventListener("resize", updateTopBarHeight);

    return () => window.removeEventListener("resize", updateTopBarHeight);
  }, [currentQuestionNo, surveyFinished]);

  // Persist custom end screens from the rich response before submission overwrites the store

  useEffect(() => {
    const arr = normalizeEndScreens(get_brief_response?.response);

    if (Array.isArray(arr) && arr.length > 0) {
      setEndScreensPersisted(arr);
    }
  }, [get_brief_response?.response]);

  const applySkipLogic = (answers, seqMap, currentFeedback) => {
    
    const newRuleFeedback = AuditRunRules(
      questionList,
      orgRules,
      answers,
      surveyStandards
    );

    // console.log("newRuleFeedback", newRuleFeedback, totalRows);
    const updated = { ...seqMap };
    

    // Treat only meaningful values as real responses; "false" and empty objects are considered empty
    const hasRealResponse = (resp) => {
      try {
        if (resp === undefined || resp === null) return false;
        if (resp === false) return false;
        if (typeof resp === "string") return resp.trim().length > 0;
        if (typeof resp === "object") return Object.keys(resp).length > 0;
        return true;
      } catch {
        return false;
      }
    };

    // Get all questions in feedback-aiFollowUp pairs

    const feedbackQuestions = [];

    const aiFollowUpQuestions = [];

    // First, collect all feedback and aiFollowUp questions

    Object.entries(updated).forEach(([key, q]) => {
      if (q.quesType === feedbackTypeQuestion) {
        feedbackQuestions.push({ key, q });
      } else if (q.quesType === followupAiTypeQuestion) {
        aiFollowUpQuestions.push({ key, q });
      }
    });
    

    // Sort them by their keys (which should be the question numbers)

    feedbackQuestions.sort((a, b) => parseInt(a.key) - parseInt(b.key));

    aiFollowUpQuestions.sort((a, b) => parseInt(a.key) - parseInt(b.key));

    if (feedbackQuestions.length > 0) {
      // Determine how many should be active based on newRuleFeedback length

      const activeCount = Math.min(newRuleFeedback.length, totalRows);

      const metaKey = (meta) => {
        try {
          if (!meta) return "";
          // Build a stable identity for the rule driving this slot
          return JSON.stringify([
            meta?.id ?? null,
            meta?.ques_order ?? null,
            meta?.dimension ?? null,
            meta?.factor ?? null,
            meta?.type ?? null,
          ]);
        } catch (e) {
          return "";
        }
      };

      const responseMetaKey = (resp) => {
        try {
          if (!resp) return "";
          return JSON.stringify([
            resp?.id ?? null,
            // prefer ques_order; fall back to org_ref_ques_order for follow-ups
            resp?.ques_order ??
              resp?.org_ref_ques_order ??
              resp?.org_ques_order ??
              null,
            resp?.dimension ?? null,
            resp?.factor ?? null,
            resp?.type ?? null,
          ]);
        } catch (e) {
          return "";
        }
      };

      const looseMatch = (resp, meta) => {
        try {
          if (!resp || !meta) return false;
          const sameId = (resp?.id ?? null) === (meta?.id ?? null);
          const sameOrder =
            (resp?.ques_order ?? resp?.org_ref_ques_order ?? null) ===
            (meta?.ques_order ?? null);
          const sameDim =
            (resp?.dimension ?? null) === (meta?.dimension ?? null);
          const sameFac = (resp?.factor ?? null) === (meta?.factor ?? null);
          const sameType = (resp?.type ?? null) === (meta?.type ?? null);
          // Allow minor diffs; prioritize id + order + type
          return (
            (sameId && sameOrder) ||
            (sameId && sameType) ||
            (sameOrder && sameType) ||
            (sameId && sameDim && sameFac)
          );
        } catch {
          return false;
        }
      };

      // Snapshot previous bindings and responses keyed by rule identity (ignore empty keys)
      const prevByMeta = new Map();
      feedbackQuestions.forEach((item, idx) => {
        const prevMeta = updated[item.key]?.ruleMeta || null;
        let keyStr = metaKey(prevMeta);
        if (!keyStr) {
          keyStr = responseMetaKey(updated[item.key]?.response);
        }
        if (keyStr && !prevByMeta.has(keyStr)) {
          const prevFollowKey = aiFollowUpQuestions[idx]?.key;
          prevByMeta.set(keyStr, {
            itemKey: item.key,
            index: idx,
            meta: prevMeta,
            response: updated[item.key]?.response,
            clicked: updated[item.key]?.clicked,
            followKey: prevFollowKey,
            followResponse: prevFollowKey
              ? updated[prevFollowKey]?.response
              : undefined,
          });
        }
      });
      // Also include responses from the prior sequence map to survive key re-indexing
      // CRITICAL: Use seqMap (the param) not questionSequenceMap (stale state)
      try {
        const prior = seqMap || {};
        Object.keys(prior).forEach((k) => {
          const entry = prior[k];
          if (!entry) return;
          const resp = entry.response;
          const rKey = responseMetaKey(resp);
          const mKey = metaKey(entry.ruleMeta || null);
          const useKey = rKey || mKey;
          if (useKey && !prevByMeta.has(useKey)) {
            prevByMeta.set(useKey, {
              itemKey: k,
              index: null,
              meta: entry.ruleMeta || null,
              response: resp,
              clicked: entry.clicked,
              followKey: null,
              followResponse: undefined,
            });
          }
        });
      } catch (e) {}

      // Set skip property, attach ruleMeta to each active slot, and clear stale responses on change

      feedbackQuestions.forEach((item, index) => {
        const shouldSkip = index >= activeCount;

        const slotKey = item.key;

        const followKey =
          index < aiFollowUpQuestions.length
            ? aiFollowUpQuestions[index].key
            : null;

        // Update skip flags
        updated[slotKey].skip = shouldSkip;
        if (followKey) {
          updated[followKey].skip = shouldSkip;
          // Ensure follow-up references its paired feedback slot after any reorder
          try {
            const refId = parseInt(slotKey, 10);
            if (!Number.isNaN(refId)) {
              updated[followKey].quesRefId = refId;
            }
          } catch {}
        }
        

        // Active slot: bind rule and clear responses if the bound rule changed
        if (!shouldSkip) {
          const newMeta = newRuleFeedback[index] || null;
          const prevMeta = updated[slotKey]?.ruleMeta || null;
          const newKey = metaKey(newMeta);
          const prevKey = metaKey(prevMeta);
          const changed = prevKey !== newKey;
          
          if (DISABLE_FEEDBACK_MIGRATION) {
            // Bind new rule
            updated[slotKey].ruleMeta = newMeta;
            // If binding changed, only clear when the existing response does NOT match the new rule
            if (changed) {
              const existingResp = updated[slotKey]?.response;
              const matchesNewRule =
                looseMatch(existingResp, newMeta) ||
                responseMetaKey(existingResp) === metaKey(newMeta);
              if (!matchesNewRule) {
                updated[slotKey] = {
                  ...updated[slotKey],
                  response: undefined,
                  clicked: false,
                };
                if (followKey && updated[followKey]) {
                  updated[followKey] = {
                    ...updated[followKey],
                    response: undefined,
                    clicked: false,
                  };
                }
              }
            }
            return; // skip migration/hydration below
          }
          if (changed) {
          }

          // Bind the new meta
          updated[slotKey].ruleMeta = newMeta;

          if (changed) {
            const hadPrevBinding = !!prevKey; // only act destructively if there was a real previous binding
            // Try to migrate responses from the slot that previously held this rule
            let donor = newKey ? prevByMeta.get(newKey) : undefined;
            if (!donor) {
              // Fallback: try to find by response identity equivalence
              for (const v of prevByMeta.values()) {
                if (
                  looseMatch(v.response, newMeta) ||
                  metaKey(v.meta) === newKey ||
                  responseMetaKey(v.response) === newKey
                ) {
                  donor = v;
                  break;
                }
              }
            }
            const donorHasResp = !!(donor && hasRealResponse(donor.response));
            // consider placeholders as empty: feedback objects without meaningful text, follow-ups without prompt/feedback
            const slotResp = updated[slotKey]?.response;
            const isFeedbackSlot =
              updated[slotKey]?.quesType === feedbackTypeQuestion;
            const isFollowUpSlot =
              updated[slotKey]?.quesType === followupAiTypeQuestion;
            const feedbackMissing =
              isFeedbackSlot &&
              (!slotResp ||
                slotResp?.feedback === undefined ||
                slotResp?.feedback === null ||
                (typeof slotResp?.feedback === "string" &&
                  slotResp.feedback.trim().length === 0));
            const followupMissing =
              isFollowUpSlot &&
              (!slotResp ||
                ((slotResp?.feedback === undefined ||
                  slotResp?.feedback === null ||
                  (typeof slotResp?.feedback === "string" &&
                    slotResp.feedback.trim().length === 0)) &&
                  (slotResp?.prompt_question === undefined ||
                    slotResp?.prompt_question === null ||
                    (typeof slotResp?.prompt_question === "string" &&
                      slotResp.prompt_question.trim().length === 0))));
            const slotHasNoResp =
              !hasRealResponse(slotResp) || feedbackMissing || followupMissing;
            let didHydrate = false;

            if (donorHasResp && slotHasNoResp) {
              updated[slotKey] = {
                ...updated[slotKey],
                response: donor.response,
                clicked: donor.clicked ?? true,
              };
              // Move paired follow-up response as well if available
              if (
                followKey &&
                donor.followKey &&
                updated[followKey] &&
                updated[donor.followKey]
              ) {
                const donorFResp = donor.followResponse;
                if (donorFResp !== undefined) {
                  updated[followKey] = {
                    ...updated[followKey],
                    response: donorFResp,
                    clicked: true,
                  };
                }
                // Clear from donor follow to avoid duplication
                if (donor.followKey !== followKey) {
                  updated[donor.followKey] = {
                    ...updated[donor.followKey],
                    response: undefined,
                    clicked: false,
                  };
                }
              }
              // Clear from donor slot to avoid duplication
              if (donor.itemKey !== slotKey) {
                updated[donor.itemKey] = {
                  ...updated[donor.itemKey],
                  response: undefined,
                  clicked: false,
                };
              }
            } else if (hadPrevBinding && !donorHasResp) {
              // Hydrate from stored feedback history if present and slot is effectively empty
              try {
            if (
              slotHasNoResp &&
              Array.isArray(currentFeedback) &&
              newMeta
            ) {
              const matchFromHistory = currentFeedback.find((fb) => {
                    try {
                      const sameId = (fb?.id ?? null) === (newMeta?.id ?? null);
                      const sameOrder =
                        (fb?.ques_order ??
                          fb?.org_ref_ques_order ??
                          fb?.org_ques_order ??
                          null) === (newMeta?.ques_order ?? null);
                      const sameDim =
                        (fb?.dimension ?? null) ===
                        (newMeta?.dimension ?? null);
                      const sameFac =
                        (fb?.factor ?? null) === (newMeta?.factor ?? null);
                      const sameType =
                        (fb?.type ?? null) === (newMeta?.type ?? null);
                      const hasText =
                        typeof fb?.feedback === "string" &&
                        fb.feedback.trim().length > 0;
                      return (
                        hasText &&
                        ((sameId && sameOrder) ||
                          (sameId && sameType) ||
                          (sameOrder && sameType) ||
                          (sameId && sameDim && sameFac))
                      );
                    } catch {
                      return false;
                    }
                  });
                  if (matchFromHistory) {
                    updated[slotKey] = {
                      ...updated[slotKey],
                      response: {
                        ...matchFromHistory,
                        survey_q_id: updated[slotKey]?.id,
                        ques_sort_order: updated[slotKey]?.id,
                      },
                      clicked: true,
                    };
                    didHydrate = true;
                  }
                }
              } catch {}
              // Only clear stale responses if there was a previous real binding and no viable donor
              if (!didHydrate) {
                updated[slotKey] = {
                  ...updated[slotKey],
                  response: undefined,
                  clicked: false,
                };
                if (followKey && updated[followKey]) {
                  updated[followKey] = {
                    ...updated[followKey],
                    response: undefined,
                    clicked: false,
                  };
                }
              }
            } // else: first-time binding, keep any existing responses intact
          }

          // Final safety: if active slot still lacks meaningful feedback, hydrate from history
          try {
            const slotResp2 = updated[slotKey]?.response;
            const isFeedbackSlot2 =
              updated[slotKey]?.quesType === feedbackTypeQuestion;
            const missingFeedback =
              isFeedbackSlot2 &&
              (!slotResp2 ||
                slotResp2?.feedback === undefined ||
                slotResp2?.feedback === null ||
                (typeof slotResp2?.feedback === "string" &&
                  slotResp2.feedback.trim().length === 0));
            // IMPORTANT: Only allow this hydration on rule changes. If the user cleared
            // the text intentionally (empty string) without a binding change, do NOT rehydrate.
            if (
              changed &&
              missingFeedback &&
              Array.isArray(currentFeedback) &&
              newMeta
            ) {
              const match = currentFeedback.find((fb) => {
                try {
                  const sameId = (fb?.id ?? null) === (newMeta?.id ?? null);
                  const sameOrder =
                    (fb?.ques_order ??
                      fb?.org_ref_ques_order ??
                      fb?.org_ques_order ??
                      null) === (newMeta?.ques_order ?? null);
                  const sameDim =
                    (fb?.dimension ?? null) === (newMeta?.dimension ?? null);
                  const sameFac =
                    (fb?.factor ?? null) === (newMeta?.factor ?? null);
                  const sameType =
                    (fb?.type ?? null) === (newMeta?.type ?? null);
                  const hasText =
                    typeof fb?.feedback === "string" &&
                    fb.feedback.trim().length > 0;
                  return (
                    hasText &&
                    ((sameId && sameOrder) ||
                      (sameId && sameType) ||
                      (sameOrder && sameType) ||
                      (sameId && sameDim && sameFac))
                  );
                } catch {
                  return false;
                }
              });
              if (match) {
                updated[slotKey] = {
                  ...updated[slotKey],
                  response: {
                    ...match,
                    survey_q_id: updated[slotKey]?.id,
                    ques_sort_order: updated[slotKey]?.id,
                  },
                  clicked: true,
                };
              }
            }
          } catch {}
        }
      });

      // Rebalance misplaced responses: if a slot holds a response that belongs to a different rule,
      // move it to the slot that now binds that rule (only if target is empty)
      try {
        const feedbackSlots = feedbackQuestions.map((x) => x.key);
        const followSlots = aiFollowUpQuestions.map((x) => x.key);
        const newKeyToTargets = new Map();
        for (let i = 0; i < Math.min(activeCount, feedbackSlots.length); i++) {
          const keyStr = metaKey(newRuleFeedback[i] || null);
          if (keyStr) {
            newKeyToTargets.set(keyStr, {
              feedbackKey: feedbackSlots[i],
              followKey: followSlots[i],
            });
          }
        }
        for (let i = 0; i < feedbackSlots.length; i++) {
          const srcFeedbackKey = feedbackSlots[i];
          const srcFollowKey = followSlots[i];
          const srcResp = updated[srcFeedbackKey]?.response;
          const srcRuleKey = metaKey(updated[srcFeedbackKey]?.ruleMeta || null);
          const respKey = responseMetaKey(srcResp);
          // If the response belongs to a different rule than the one bound to this slot, try to move it
          if (hasRealResponse(srcResp) && respKey && respKey !== srcRuleKey) {
            const target = newKeyToTargets.get(respKey);
            if (target && target.feedbackKey !== srcFeedbackKey) {
              const tgtHasResp = hasRealResponse(
                updated[target.feedbackKey]?.response
              );
              if (!tgtHasResp) {
                // Move feedback response
                updated[target.feedbackKey] = {
                  ...updated[target.feedbackKey],
                  response: srcResp,
                  clicked: true,
                };
                updated[srcFeedbackKey] = {
                  ...updated[srcFeedbackKey],
                  response: undefined,
                  clicked: false,
                };
                // Move paired follow-up if present
                if (srcFollowKey && target.followKey && updated[srcFollowKey]) {
                  const srcFResp = updated[srcFollowKey]?.response;
                  const tgtFHasResp = target.followKey
                    ? hasRealResponse(updated[target.followKey]?.response)
                    : false;
                  if (hasRealResponse(srcFResp) && !tgtFHasResp) {
                    updated[target.followKey] = {
                      ...updated[target.followKey],
                      response: srcFResp,
                      clicked: true,
                    };
                    updated[srcFollowKey] = {
                      ...updated[srcFollowKey],
                      response: undefined,
                      clicked: false,
                    };
                    // Also realign follow-up's ref to its new paired feedback slot
                    try {
                      const refId = parseInt(String(target.feedbackKey), 10);
                      if (!Number.isNaN(refId)) {
                        updated[target.followKey].quesRefId = refId;
                      }
                    } catch {}
                  }
                }
              } else {
              }
            }
          }
        }
      } catch (e) {}

      // Final mismatch cleanup: clear responses that don't belong to the currently bound rule
      try {
        const feedbackSlots = feedbackQuestions.map((x) => x.key);
        for (let i = 0; i < Math.min(activeCount, feedbackSlots.length); i++) {
          const slotKey = feedbackSlots[i];
          const boundRuleKey = metaKey(updated[slotKey]?.ruleMeta || null);
          const respKey = responseMetaKey(updated[slotKey]?.response);
          if (respKey && boundRuleKey && respKey !== boundRuleKey) {
            // Clear stale response on feedback slot
            updated[slotKey] = {
              ...updated[slotKey],
              response: undefined,
              clicked: false,
            };
            // Also clear paired follow-up if exists
            const fKey =
              i < aiFollowUpQuestions.length
                ? aiFollowUpQuestions[i].key
                : null;
            if (fKey && updated[fKey]) {
              updated[fKey] = {
                ...updated[fKey],
                response: undefined,
                clicked: false,
              };
            }
          }
        }
      } catch (e) {}
    }

    /* ---------- NEW  : MODULAR  ASK-ON-REF LOGIC ---------- */

    const inRange = (score, [lo, hi]) =>
      typeof score === "number" &&
      Array.isArray(lo) === false &&
      score >= lo &&
      score <= hi;

    Object.entries(updated).forEach(([id, q]) => {
      if (!q.askOnRef || !q.askOnRef.enabled) return; // nothing to do

      const refId = q.askOnRefQID; // we stored this earlier

      const refAns = updated[refId]?.response;

      const score = refAns?.response ?? refAns?.value; // whichever field you're using

      let show = true;

      if (score !== undefined) {
        const { operator, value } = q.askOnRef; // e.g. ">", [0,5]

        switch (operator) {
          case ">":
            show = score > value;
            break;

          case "<":
            show = score < value;
            break;

          case ">=":
            show = score >= value;
            break;

          case "<=":
            show = score <= value;
            break;

          case "=":
            show = score === value;
            break;

          case "range":

          default: // treat anything not recognised as range
            show = Array.isArray(value) ? inRange(score, value) : true;
        }
      }

      updated[id].skip = !show;
    });

    // Hard guarantee: never alter standard question responses/clicked in this function
    try {
      Object.keys(updated).forEach((key) => {
        const orig = seqMap[key];
        if (orig && orig.quesType === questionTypeQuestion) {
          const cur = updated[key] || {};
          updated[key] = {
            ...cur,
            response: orig.response,
            clicked: orig.clicked,
          };
        }
      });
    } catch (e) {}

    // BULLETPROOF: never_ask category questions must always remain skipped,
    // regardless of any rule logic that may have touched them above.
    Object.keys(updated).forEach((key) => {
      if (updated[key]?.from?.startsWith("never_ask")) {
        updated[key] = { ...updated[key], skip: true };
      }
    });

    return { newRuleFeedback, updated };
  };

  // console.log("orgRules", orgRules)

  // console.log("RuleFeedback", ruleFeedback);

  useEffect(() => {
    setTimeout(() => {
      if (get_brief_response?.validation_token === null) {
        // console.log("NEW_VALIDATION_TOKEN updated **************************");

        const _newToken = uuidv4();

        localStorage.setItem("validation_token", _newToken);

        LOCAL_VALIDATION_TOKEN = _newToken;
      }
    }, 500); // 1000 milliseconds = 1 second
  }, [get_brief_response.validation_token]);

  // console.log("modSurveyRule", modSurveyRule)

  // console.log("orgRules", orgRules)

  // // console.log("questionAnswers", questionAnswers)

  // console.log("get_brief_response?.response?.stored_response", get_brief_response?.response?.stored_response)

  // console.log("storedResponseFound", storedResponseFound)

  // console.log("storedResponse", storedResponse)

  // console.log("get_brief_response?.response?.stored_response", get_brief_response?.response?.stored_response)

  // console.log("storedResponse validation_token", storedResponse?.validation_token)

  // console.log("get_brief_response?.validation_token",get_brief_response?.validation_token)

  // console.log(questionSequenceMap)

  // console.log("formPayload",formPayload)

  // console.log("survey standards", get_brief_response?.response?.survey_standards)

  // ModularSurveyCheck

  // console.log("ModularSurveyRule get_brief_response", get_brief_response)

  useEffect(() => {
    if (get_brief_response?.surveyComponents) {
      const surveyComponents = get_brief_response?.surveyComponents;

      setModSurveyRule(ModularSurveyCheck({ surveyComponents }));
    }
  }, [get_brief_response.surveyComponents]);

  useEffect(() => {
    setSurveyStandards(get_brief_response?.response?.survey_standards);
  }, [get_brief_response.response.survey_standards]);

  useEffect(() => {
    setSortOrder(
      get_brief_response?.response?.organization_services?.find(
        (f) => f.name == "Audit"
      )?.question_sort_order
    );
  }, [get_brief_response.response.organization_services]);

  // // modSurveyRule

  // useEffect(() => {

  //   if (!surveyDeleted) {

  //     if (modSurveyRule && token) {

  //       modSurveyRule.map((ms) => {

  //         dispatch({

  //           type: SG_GET_ALL_MODULAR_QUESTIONS,

  //           payload: `?token=${token}&component=${ms?.value}`,

  //         });

  //         return null;

  //       });

  //     }

  //   }

  // }, [dispatch, modSurveyRule, token, surveyDeleted]);

  // console.log("get_brief_response?.modular_question ===========", modSurveyRule)

  // console.log("get_brief_response?.modular_question ===========", get_modular_questions)

  // console.log(get_brief_response)

  // console.log(get_brief_response?.visual_question)

  // console.log(totalQuestions)

  // console.log("questionSequenceMap", questionSequenceMap)

  // console.log("show not have In Survey Personality enabled")

  useEffect(() => {
    const SurveyPersonality =
      get_brief_response?.response?.organization_services?.filter(
        (os) => os.name === "In Survey Personality"
      )?.[0];

    // console.log(SurveyPersonality)

    // console.log("should not contain in_survey_personality")

    // console.log(get_brief_response?.response?.employee_survey_spec?.['survey_personality'])

    const sp_earlier =
      get_brief_response?.response?.employee_survey_spec?.[
        "survey_personality"
      ];

    if (SurveyPersonality?.enabled === true) {
      // personality completed ealier dont ask again but inject in the response

      if (sp_earlier) {
        setShowInSurveyPersonality(false);

        // setSurveyPersonalityResp(sp_earlier?.survey_personality)
      } else {
        // console.log(get_brief_response?.response?.employee_survey_spec)

        // personality survey completed and refreshing and collection from store data

        if (get_brief_response?.in_survey_personality) {
          setShowInSurveyPersonality(false);

          // setSurveyPersonalityResp(get_brief_response?.survey_personality)
        } else {
          setShowInSurveyPersonality(true);
        }
      }
    } else {
      setShowInSurveyPersonality(false);
    }
  }, [
    get_brief_response.organization_services,

    get_brief_response.in_survey_personality,

    get_brief_response.survey_personality,

    get_brief_response.response.employee_survey_spec,

    get_brief_response.response.organization_services,
  ]);

  // console.log("surveyFeedbackResp", surveyFeedbackResp)

  // console.log(get_brief_response?.response?.stored_response)

  // // console.log("surveyModularResp", surveyModularResp)

  useEffect(() => {
    if (get_brief_response?.response?.stored_response?.answers) {
      setQuestionAnswers(
        get_brief_response?.response?.stored_response?.answers
      );
    }

    if (formPayload?.feedback?.length > 0) {
      setSurveyFeedbackResp(formPayload?.feedback);
    } else {
      setSurveyFeedbackResp(
        get_brief_response?.response?.stored_response?.feedback
      );
    }

    if (get_brief_response?.response?.stored_response?.modular_response) {
      setSurveyModularResp(
        get_brief_response?.response?.stored_response?.modular_response
      );
    }

    if (get_brief_response?.response?.stored_response?.survey_personality) {
      setSurveyPersonalityResp(
        get_brief_response?.response?.stored_response?.survey_personality
      );
    }
  }, [get_brief_response.response.stored_response, formPayload.feedback]);

  // Hydrate local state from storedResponse immediately after resume is accepted
  useEffect(() => {
    if (showingStoredResponse && storedResponse) {
      if (storedResponse?.answers) {
        setQuestionAnswers(storedResponse.answers);
      }
      if (storedResponse?.feedback) {
        setSurveyFeedbackResp(storedResponse.feedback);
      }
      if (storedResponse?.modular_response) {
        setSurveyModularResp(storedResponse.modular_response);
      }
      if (storedResponse?.survey_personality) {
        setSurveyPersonalityResp(storedResponse.survey_personality);
      }

      setFormPayload({
        visual_question: storedResponse?.visual_question,
        current_question: storedResponse?.current_question,
        current_answer: storedResponse?.current_answer,
        high_answer: storedResponse?.high_answer,
        answers: storedResponse?.answers || { categories: {}, questions: {}, comments: {} },
        complete: storedResponse?.complete || false,
        validation_token: LOCAL_VALIDATION_TOKEN,
        survey_personality: storedResponse?.survey_personality || {},
        modular_response: storedResponse?.modular_response || {},
        questionSequenceMap: storedResponse?.questionSequenceMap || {},
        feedback: storedResponse?.feedback || [],
      });
    }
  }, [showingStoredResponse, storedResponse]);

  useEffect(() => {
    const arrangedQuestions = arrange_Questions(
      get_brief_response?.response?.questions
    );

    setQuestionList(arrangedQuestions);

    setBriefResponse(get_brief_response);

    //

    setOrgRules(get_brief_response?.response?.organization_info?.rules);

    //

    setSurveyDeleted(
      get_brief_response?.to_delete ? get_brief_response?.to_delete : false
    );

    setSurveyDeletedOn(
      get_brief_response?.deleted_on ? get_brief_response?.deleted_on : false
    );

    setSurveyStatus(
      get_brief_response?.survey_status ? get_brief_response?.survey_status : 0
    );

    setOrganizationName(get_brief_response?.response?.organization_name);

    if (get_brief_response?.response?.employee_category) {
      if (get_brief_response?.response?.organization_info?.organization == 1) {
        setOrganizationName(
          `${get_brief_response?.response?.organization_name}`
        );
      } else {
        let EmpPrimary = get_brief_response?.response?.employee_category.find(
          (ec) => ec?.priority === "primary"
        )?.value;

        const primaryFrench =
          get_brief_response?.response?.primary_question[0]?.options?.find(
            (f) => f.name == EmpPrimary
          )?.fr;

        if (language == "FR" && primaryFrench) {
          EmpPrimary = primaryFrench;
        }

        setTeamName(EmpPrimary);

        if (
          get_brief_response?.response?.organization_info?.organization == 2
        ) {
          setOrganizationName(`${EmpPrimary}`);
        } else {
          setOrganizationName(
            `${get_brief_response?.response?.organization_name} - ${EmpPrimary}`
          );
        }
      }
    }

    let _id = "";

    let _response = 0;

    let subfactorFound = false;

    let _subfactor = null;

    const SurveyName = get_brief_response?.response?.survey_name;

    // setSurveyName(get_brief_response?.response?.survey_name)

    if (get_brief_response?.response?.primary_question) {
      get_brief_response.response.primary_question.map((pq) => {
        _id = pq.id;

        if (pq?.subfactor) {
          subfactorFound = true;
        }

        pq &&
          pq.answers.map((aq) => {
            if (aq?.name === SurveyName) {
              if (subfactorFound) {
                _subfactor = aq?.id;

                _response = aq?.parent_id;
              } else {
                _response = aq?.id;
              }
            }

            return null;
          });

        return null;
      });
    }

    if (!_response && _response !== null && Array.isArray(employeeCategory)) {
      const fallbackPrimary = employeeCategory.find(
        (cat) => cat?.priority === "primary"
      );

      if (fallbackPrimary) {
        _response = fallbackPrimary?.value_id ?? null;

        _id = fallbackPrimary?.name_id ?? _id;

        if (_subfactor === null && fallbackPrimary?.subfactor_id) {
          _subfactor = fallbackPrimary.subfactor_id;
        }
      }
    }

    if (_response === 0 || _response === "0") {
      _response = null;
    }

    setBriefResponseId(get_brief_response?.id);

    setPrimaryCategory({
      id: _id,

      response: _response,

      subfactor: _subfactor,

      priority: "primary",
    });
  }, [get_brief_response, employeeCategory]);

  useEffect(() => {
    if (get_brief_response?.response?.questions?.title) {
      setStoredTitle(get_brief_response?.response?.questions?.title);
    }

    if (get_brief_response?.response?.questions?.language) {
      // console.log(get_brief_response)

      if (get_brief_response?.response?.questions?.languages) {
        setLanguages(get_brief_response?.response?.questions?.languages);
      }

      setShowLanguage(true);

      // console.log(get_brief_response)
    }
  }, [get_brief_response]);

  // question no based on role skip logic

  // step 1 set role

  useEffect(() => {
    if (questionAnswers?.categories) {
      const CatRes = Object.values(questionAnswers?.categories).filter(
        (value) => value !== null
      );

      setCheckRole(
        CatRes.filter((ct) => ct.priority === "secondary")?.[0]?.response
      );
    }

    // console.log("setCheckRole changed")
  }, [questionAnswers]);

  // Reactively update skip logic when checkRole changes (without rebuilding)
  useEffect(() => {
    // Only run after survey has been initialized (check ref, not state)
    if (questionSequenceMapRef.current && questionList && checkRole !== false) {
      updateSkipLogicForRole();
    }
  }, [checkRole]);

  // // Ask Comments

  useEffect(() => {
    const _askComments = [];

    if (get_brief_response?.response?.questions?.comments) {
      if (get_brief_response?.response?.questions?.comments?.length > 0) {
        get_brief_response.response.questions.comments.map((ac, i) => {
          return _askComments.push({
            ...ac,
            id: i + 1,
            allowSkip:
              ac?.allowSkip ||
              get_brief_response?.response?.questions?.allowSkip,
          });
        });
      }
    }

    // console.log("setAskComments changed")

    setAskComments(_askComments);
  }, [get_brief_response.response.questions]);

  // console.log(get_brief_response?.response?.culture_questions)

  useEffect(() => {
    if (get_brief_response?.response) {
      // console.log("setQuestionList categoryQues setEmployeeCategory setOrganizationInfo changed")

      setEmployeeCategory(get_brief_response?.response?.employee_category);

      setOrganizationInfo(get_brief_response?.response?.organization_info);

      setCategoryQues(
        get_brief_response?.response?.culture_questions?.sort(
          (a, b) => a?.id - b?.id
        )
      );
    }
  }, [get_brief_response.response]);

  // console.log(storedResponse?.validation_token === get_brief_response?.response?.validation_token)

  // console.log("VALIDATION_TOKEN ", VALIDATION_TOKEN )

  // console.log("get_brief_response?.response?.validation_token", get_brief_response?.response?.validation_token)

  // console.log("et_brief_response?.response?.stored_response?.high_answer > 4", get_brief_response?.response?.stored_response?.high_answer > 4)

  // console.log(get_brief_response?.response?.stored_response)

  // primary Response

  useEffect(() => {
    setStoredResponseFound(false);

    if (get_brief_response?.response?.validation_token) {
      if (get_brief_response?.response?.stored_response?.high_answer > 4) {
        // if clicked once it showing_stored_response === true, show only if its false

        // it resets to false on refresh

        const uuid_str = (get_brief_response?.response?.validation_token || "")

          .toLowerCase()

          .trim();

        const valid_token = LOCAL_VALIDATION_TOKEN?.toLowerCase().trim();

        if (showingStoredResponse === false) {
          // console.log("I am heree eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")

          if (uuid_str === valid_token) {
            // console.log("matched uuid_str === valid_token +++++++++++++++++++++++++++++++++")

            setStoredResponseFound(true);

            setStoredResponse(get_brief_response?.response?.stored_response);
          }
        }
      }
    }
  }, [get_brief_response.response, showingStoredResponse]);

  // the core list for managing survey within the app

  useEffect(() => {
    const _seq = {};

    let visualTotal = 0;

    const resetResponsesOnChange = {};

    // Use the intro configuration builder; include custom intro screens if provided

    const introScreens = buildIntroSequence(
      organizationInfo,

      sortOrder,

      get_brief_response?.response?.questions?.custom_intro_screens || [],

      get_brief_response?.response?.questions?.default_intro_screens || null
    );

    // Apply intro screens to the sequence

    introScreens.forEach((screen) => {
      _seq[screen.id] = screen;
    });

    // Set the counters based on intro screens count

    let running_total = introScreens.length;

    let total = introScreens.length;

    let introQuestion = introScreens.length;

    let CatLength = 0;

    // ai feedback questions

    let feedbackLength = 0;

    const _prevResp = {};

    const _neverAskResp = {};

    // Decide whether demographics/category questions should be moved to the end

    const demographicsAtEnd = !!(
      get_brief_response?.response?.question?.demographics_at_end ||
      get_brief_response?.response?.questions?.demographics_at_end
    );

    const removeCategoryThanks = !!(
      get_brief_response?.response?.question?.remove_category_thanks ||
      get_brief_response?.response?.questions?.remove_category_thanks
    );

    const hasCustomCategoryIntro = (() => {
      try {
        const intro =
          get_brief_response?.response?.questions?.custom_category_intro;

        if (!intro) return false;

        const en = typeof intro.text === "string" ? intro.text.trim() : "";

        const fr = typeof intro.fr === "string" ? intro.fr.trim() : "";

        return en.length > 0 || fr.length > 0;
      } catch (e) {
        return false;
      }
    })();

    const insertCategoryIntro = () => {
      running_total += 1;

      visualTotal += 1;

      total += 1;

      _seq[running_total] = {
        id: running_total,

        quesType: categoryTypeQuestion,

        buttonType: nextQuestionBtn,

        skip: false,

        sno: running_total,

        visualTotal,

        clicked: true,

        response: { response: true },

        buttonText: "Next",

        from: "category_intro",
      };
    };

    // Helper to append category/demographic questions to the sequence at the current position

    const appendCategoryQuestions = () => {
      if (!categoryQues) return;

      let catQuesNo = 0;

      categoryQues.map((q) => {
        if (q?.input === "always_ask") {
          running_total += 1;

          visualTotal += 1;

          CatLength += 1;

          total += 1;

          catQuesNo += 1;

          _seq[running_total] = {
            id: running_total,

            from: `always_ask ${q.id}`,

            category_question_id: q.id,

            quesType: categoryTypeQuestion,

            buttonType: nextQuestionBtn,

            skip: false,

            sno: running_total,

            catQuesNo,

            visualTotal,

            clicked: false,

            response: false,

            buttonText: "Next",
          };

          return null;
        }

        // change this to ids

        if (q?.input === "ask_if_not_found") {
          // setPrevFoundResponse

          const _empCat = employeeCategory?.filter(
            (ec) => ec?.name_id === q.id
          )?.[0]?.value_id;

          if (_empCat) {
            // found dont ask

            const _response = q.answers.filter((rq) => rq?.id === _empCat)?.[0]
              ?.id;

            running_total += 1;

            CatLength += 1;

            total += 0;

            catQuesNo += 1;

            _seq[running_total] = {
              id: running_total,

              from: `ask_if_not_found ${q.id}`,

              category_question_id: q.id,

              quesType: categoryTypeQuestion,

              buttonType: nextQuestionBtn,

              skip: true,

              sno: running_total,

              catQuesNo,

              visualTotal,

              clicked: false,

              category_id: q.id,

              response: { response: _response },

              priority: q.priority,

              buttonText: "Next",
            };

            _prevResp[running_total] = {
              id: q.id,

              response: _response,

              priority: q.priority,
            };
          } else {
            //

            running_total += 1;

            CatLength += 1;

            visualTotal += 1;

            total += 1;

            catQuesNo += 1;

            _seq[running_total] = {
              id: running_total,

              from: `ask_if_not_found  ${q.id}`,

              category_question_id: q.id,

              quesType: categoryTypeQuestion,

              buttonType: nextQuestionBtn,

              skip: false,

              sno: running_total,

              catQuesNo,

              visualTotal,

              clicked: false,

              response: false,

              buttonText: "Next",
            };
          }

          return null;
        }

        // change this to ids

        // not shown in total

        if (q?.input === "never_ask") {
          const _empCat = employeeCategory?.filter(
            (ec) => ec?.name_id === q.id
          )?.[0]?.value_id;

          running_total += 1;

          CatLength += 1;

          total += 0;

          catQuesNo += 1;

          _seq[running_total] = {
            id: running_total,

            from: `never_ask  ${q?.id}`,

            category_question_id: q.id,

            quesType: categoryTypeQuestion,

            buttonType: nextQuestionBtn,

            skip: true,

            sno: running_total,

            catQuesNo,

            visualTotal,

            clicked: false,

            category_id: q.id,

            response: { response: _empCat ? _empCat : null },

            priority: q.priority,

            buttonText: "Next",
          };

          _neverAskResp[running_total] = {
            id: q.id,

            response: _empCat ? _empCat : null,

            priority: q.priority,
          };

          return null;
        }

        // no input type found show in total

        if (!q?.input) {
          running_total += 1;

          CatLength += 1;

          total += 1;

          visualTotal += 1;

          catQuesNo += 1;

          _seq[running_total] = {
            id: running_total,

            from: `undefined`,

            category_question_id: q.id,

            quesType: categoryTypeQuestion,

            buttonType: nextQuestionBtn,

            skip: false,

            sno: running_total,

            catQuesNo,

            visualTotal,

            clicked: false,

            response: false,

            buttonText: "Next",
          };
        }

        return null;
      });

      // category completed

      if (!removeCategoryThanks && total > 4) {
        running_total += 1;

        total += 1;

        _seq[running_total] = {
          id: running_total,

          sort_order: running_total,

          quesType: categoryTypeQuestion,

          total: running_total,

          visualTotal,

          skip: false,

          buttonType: nextQuestionBtn,

          organizationName: organizationName,

          clicked: true,

          response: { response: true },

          buttonText: "Next",
        };
      }

      // Persist pre-filled category responses for submission

      setPrevFoundResponse(_prevResp);

      setNeverAskResponse(_neverAskResp);
    };

    // Insert categories now unless they should be moved to the end

    if (!demographicsAtEnd) {
      if (hasCustomCategoryIntro) {
        insertCategoryIntro();
      }

      appendCategoryQuestions();
    }

    let quesLength = 0;

    if (questionList) {
      let quesListNo = 0;

      const _empCat = getCurrentCategoryUIDs();

      questionList.map((q, v) => {
        let shouldSkip = false;

        if (q?.role) {
          shouldSkip = hasMatch(q?.role, _empCat) ? false : true;
        }

        running_total += 1;

        quesListNo += 1;

        quesLength += 1;

        total += 1;

        visualTotal += 1;

        _seq[running_total] = {
          id: running_total,

          quesType: questionTypeQuestion,

          buttonType: nextQuestionBtn,

          from: shouldSkip
            ? "question skipped due to role match"
            : "question included",

          skip: shouldSkip,

          sno: running_total,

          quesListNo,

          visualTotal: visualTotal,

          clicked: false,

          response: false,

          buttonText: "Next",
        };

        return null;
      });
    }

    let maxRows =
      get_brief_response?.response?.organization_info?.rules?.filter(
        (ru) => ru?.type === "max"
      )?.[0]?.rows || 0;

    let minRows =
      get_brief_response?.response?.organization_info?.rules?.filter(
        (ru) => ru?.type === "min"
      )?.[0]?.rows || 0;

    const TotalRows = Number(maxRows) + Number(minRows);

    setTotalRows(TotalRows);

    if (TotalRows) {
      Array.from(Array(TotalRows)).map((_, i) => {
        visualTotal += 1;

        running_total += 1;

        total += 1;

        feedbackLength += 1;

        _seq[running_total] = {
          id: running_total,

          quesType: feedbackTypeQuestion,

          skip: false, // Set skip based on ruleFeedback value

          sno: running_total,

          buttonType: nextQuestionBtn,

          visualTotal,

          feedListNo: feedbackLength,

          clicked: false,

          response: false,

          buttonText: "Next",
        };

        let quesRefId = running_total;

        visualTotal += 1;

        running_total += 1;

        total += 1;

        _seq[running_total] = {
          id: running_total,

          quesType: followupAiTypeQuestion,

          skip: false, // Also skip the follow-up if the feedback is skipped

          sno: running_total,

          buttonType: nextQuestionBtn,

          visualTotal,

          feedListNo: feedbackLength,

          clicked: false,

          response: false,

          quesRefId: quesRefId,

          buttonText: "Next",
        };

        return null;

        // return console.log(rr)
      });
    }

    let commLength = 0;

    if (askComments) {
      askComments.map((q, v) => {
        running_total += 1;

        commLength += 1;

        visualTotal += 1;

        total += 1;

        _seq[running_total] = {
          id: running_total,

          quesType: commentTypeQuestion,

          buttonType: nextQuestionBtn,

          skip: false,

          sno: running_total,

          visualTotal,

          comListNo: commLength,

          clicked: false,

          response: false,

          buttonText: "Next",

          allowSkipComments: q?.allowSkip || get_brief_response?.response?.questions?.allowSkipComments,
        };

        return null;
      });
    }

    // personalityQuestion

    if (showInSurveyPersonality) {
      let inPerListNo = 0;

      // visualTotal += 1

      running_total += 1;

      feedbackLength += 1;

      total += 1;

      _seq[running_total] = {
        id: running_total,

        quesType: introSectionTypeQuestion,

        emoji: "📝",

        title: "Getting to know you",

        text: [
          "In an effort to better contextualize the feedback we have received from you, we'd like to ask you a few questions about your personality. For the following 10 questions please rate the extent to which you agree or disagree with the statement.",

          "Your data is always kept private, and no one can access your individual responses to these questions.",
        ],

        buttonType: nextQuestionBtn,

        buttonText: "I agree",

        skip: false,

        sno: running_total,

        visualTotal,

        perListNo: inPerListNo,

        clicked: false,

        response: { response: true },
      };

      personalityQuestionList.map(() => {
        visualTotal += 1;

        running_total += 1;

        feedbackLength += 1;

        total += 1;

        inPerListNo += 1;

        _seq[running_total] = {
          id: running_total,

          quesType: personalityTypeQuestion,

          skip: false,

          sno: running_total,

          buttonType: nextQuestionBtn,

          visualTotal,

          perListNo: inPerListNo,

          clicked: false,

          response: false,

          buttonText: "Next",
        };

        return null;
      });
    }

    // let _outcomeQuestions = []

    // console.log("get_modular_questions?.modular_questions", get_modular_questions?.modular_questions)

    modSurveyRule.map((modSur) => {
      const ModQues =
        get_brief_response?.modular_questions[modSur?.value]?.questions;

      // console.log("ModQues", ModQues);

      // console.log("_outcomeQuestions", _outcomeQuestions)

      // console.log("modSur", get_modular_questions?.modular_questions[modSur?.value])

      // console.log("modSur", modSur)

      // category completed

      let catTotal = 0;

      if (ModQues) {
        // to enable intro screen to modules use the code below

        // running_total += 1

        // feedbackLength += 1

        // total += 1

        // _seq[running_total] = {

        // 	id: running_total,

        // 	quesType: introSectionTypeQuestion,

        // 	emoji: '📝',

        // 	title: 'Getting to know you',

        // 	text: [`In an effort to better contextualize the feedback we have received from you, we'd like to ask you a few questions about ${modSur?.name}. `],

        // 	buttonType: nextQuestionBtn,

        // 	buttonText: 'Next',

        // 	skip: false,

        // 	sno: running_total,

        // 	visualTotal,

        // 	clicked: false,

        // 	response: {response: true,},

        // }

        let _askOnRef = null;

        let _quesOnRef = null;

        ModQues.map((MainQues) => {
          //  check for AI follow up

          // console.log("MainQues", MainQues);

          _askOnRef = null;

          _quesOnRef = null;

          // loop through each question

          MainQues.questions.map((mq) => {
            if (mq?.ask_on_ref?.enabled) {
              _askOnRef = mq?.ask_on_ref;

              // get this question id from outcomeQuestion

              // console.log("_askOnRef running_total", running_total, _askOnRef)

              const [q, s] = _askOnRef?.ref_question_id.split(".").map(Number);

              const filteredResults = Object.keys(_seq)

                .filter(
                  (key) =>
                    _seq[key].quesType === "modularOutcomeTypeQuestion" &&
                    _seq[key]?.question?.q === q &&
                    _seq[key]?.question?.s === s
                )

                .map((key) => _seq[key]);

              _quesOnRef = filteredResults?.[0]?.id;

              if (_quesOnRef) {
                if (resetResponsesOnChange[_quesOnRef]) {
                  // If it exists, add the new property

                  resetResponsesOnChange[_quesOnRef].push(running_total + 1);
                } else {
                  // If it doesn't exist, create a new object with the new property

                  resetResponsesOnChange[_quesOnRef] = [running_total + 1];
                }
              }

              // Check if _quesOnRef exists in _seq

              if (_seq[_quesOnRef]) {
                // If it exists, add the new property

                _seq[_quesOnRef].resetOnChange = true;
              } else {
                // If it doesn't exist, create a new object with the new property

                _seq[_quesOnRef] = { resetOnChange: true };
              }
            }

            if (mq?.ai_follow_up?.enabled) {
              _askOnRef = mq?.ask_on_ref;

              // get this question id from outcomeQuestion

              // console.log("_askOnRef running_total", running_total, _askOnRef)

              const [q, s] = _askOnRef?.ref_question_id.split(".").map(Number);

              const filteredResults = Object.keys(_seq)

                .filter(
                  (key) =>
                    _seq[key].quesType === "modularOutcomeTypeQuestion" &&
                    _seq[key]?.question?.q == q &&
                    _seq[key]?.question?.s == s
                )

                .map((key) => _seq[key]);

              _quesOnRef = filteredResults?.[0]?.id;

              // add the pre ai follow up question.

              running_total += 1;

              total += 1;

              visualTotal += 1;

              catTotal += 1;

              if (_quesOnRef) {
                if (resetResponsesOnChange[_quesOnRef]) {
                  // If it exists, add the new property

                  resetResponsesOnChange[_quesOnRef].push(running_total);
                } else {
                  // If it doesn't exist, create a new object with the new property

                  resetResponsesOnChange[_quesOnRef] = [running_total];
                }
              }

              // console.log("_askOnRef 1160 a", _askOnRef);

              // console.log("running_total 1160 a", running_total);

              // console.log("filteredResults", filteredResults?.[0])

              // console.log("_quesOnRef 1160 b" , _quesOnRef)

              _seq[running_total] = {
                quesType:
                  modSur?.value === "feedback_builder" && mq?.select?.enabled
                    ? modularSelectCommentTypeQuestion
                    : ModularSurveyQuestionTypes[modSur?.value],

                aiFollowUp: true,

                followUpQuestions: true,

                sno: running_total,

                q: mq?.q,

                s: mq?.s,

                id: running_total,

                sort_order: running_total,

                question: mq,

                buttonType: nextQuestionBtn,

                name: `${MainQues?.name}`,

                uniqueName: `${modSur?.value}-${MainQues?.name}`,

                total: running_total,

                askOnRef: _askOnRef,

                askOnRefQID: _quesOnRef,

                catTotal: catTotal,

                skip: false,

                visualTotal,

                value: modSur?.value,

                clicked: false,

                response: false,

                buttonText: "Next",

                fr_name: MainQues?.fr_name,

                es_name: MainQues?.es_name,

                por_name: MainQues?.por_name,

                allowSkip: mq?.allowSkip,
              };

              const _aiFollowUpList = [];

              if (mq?.ai_follow_up?.questions?.length) {
                // error in this

                mq.ai_follow_up.questions.map((fq) => {
                  _aiFollowUpList.push(running_total);

                  running_total += 1;

                  total += 1;

                  visualTotal += 1;

                  catTotal += 1;

                  if (_quesOnRef) {
                    //  console.log("resetResponsesOnChange[_quesOnRef]", resetResponsesOnChange[_quesOnRef], running_total)

                    if (resetResponsesOnChange[_quesOnRef]) {
                      // If it exists, add the new property

                      resetResponsesOnChange[_quesOnRef].push(running_total);
                    } else {
                      // If it doesn't exist, create a new object with the new property

                      resetResponsesOnChange[_quesOnRef] = [running_total];
                    }
                  }

                  _askOnRef = mq?.ask_on_ref;

                  // get this question id from outcomeQuestion

                  // console.log("_askOnRef running_total", running_total, _askOnRef)

                  const [q, s] = _askOnRef?.ref_question_id
                    .split(".")
                    .map(Number);

                  const filteredResults = Object.keys(_seq)

                    .filter(
                      (key) =>
                        _seq[key].quesType === "modularOutcomeTypeQuestion" &&
                        _seq[key]?.question?.q == q &&
                        _seq[key]?.question?.s == s
                    )

                    .map((key) => _seq[key]);

                  _quesOnRef = filteredResults?.[0]?.id;

                  // console.log("_askOnRef 1229 b", _askOnRef);

                  // console.log("running_total 1229 b", running_total);

                  // // console.log("filteredResults", filteredResults)

                  // console.log("_quesOnRef 1229 b", _quesOnRef)

                  _seq[running_total] = {
                    quesType: multiAiFollowupCommentQuestion,

                    aiFollowUp: true,

                    followUpQuestions: [..._aiFollowUpList], // Use _aiFollowUpList directly,

                    sno: running_total,

                    q: mq?.q,

                    s: mq?.s,

                    askOnRef: _askOnRef,

                    askOnRefQID: _quesOnRef,

                    q_id: fq?.id,

                    scale: mq?.scale,

                    id: running_total,

                    sort_order: running_total,

                    question: fq?.question,

                    fr: fq?.fr,

                    es: fq?.es,

                    por: fq?.por,

                    buttonType: nextQuestionBtn,

                    name: `${MainQues?.name}-aiFollowUp`,

                    uniqueName: `${modSur?.value}-${MainQues?.name}-aiFollowUp`,

                    total: running_total,

                    catTotal: catTotal,

                    skip: false,

                    visualTotal,

                    value: modSur?.value,

                    clicked: false,

                    response: false,

                    buttonText: "Next",
                    prompt: fq?.prompt,
                  };

                  return null;
                });
              }

              _askOnRef = null;

              _quesOnRef = null;

              // console.log("mq ---", running_total,  mq)

              return null;

              // Update ifollowupquestions after the loop
            }

            // console.log(modSur);

            // console.log(mq);

            running_total += 1;

            total += 1;

            visualTotal += 1;

            catTotal += 1;

            _askOnRef = mq?.ask_on_ref;

            //   // get this question id from outcomeQuestion

            let [q, s] = [0, 0];

            if (_askOnRef?.ref_question_id.split(".")) {
              [q, s] = _askOnRef?.ref_question_id.split(".");
            }

            // const [q, s] = _askOnRef?.ref_question_id.split(".").map(Number);

            const filteredResults = Object.keys(_seq)

              .filter(
                (key) =>
                  _seq[key].quesType === "modularOutcomeTypeQuestion" &&
                  // eslint-disable-next-line eqeqeq

                  _seq[key]?.question?.q == q &&
                  // eslint-disable-next-line eqeqeq

                  _seq[key]?.question?.s == s
              )

              .map((key) => _seq[key]);

            _quesOnRef = filteredResults?.[0]?.id;

            // console.log("_askOnRef 1277 c", mq);

            // console.log("_askOnRef 1277 c", _askOnRef);

            // console.log("running_total 1277 c", running_total);

            // console.log("filteredResults 1277 c", filteredResults)

            // console.log("_quesOnRef 1277 c", _quesOnRef)

            return (_seq[running_total] = {
              quesType:
                modSur?.value === "feedback_builder" && mq?.select?.enabled
                  ? modularSelectCommentTypeQuestion
                  : ModularSurveyQuestionTypes[modSur?.value],

              aiFollowUp: false,

              followUpQuestions: false,

              sno: running_total,

              q: mq?.q,

              s: mq?.s,

              id: running_total,

              sort_order: running_total,

              question: mq,

              buttonType: nextQuestionBtn,

              name:
                MainQues?.use_custom_header && organizationInfo?.custom_survey_header
                  ? organizationInfo?.custom_survey_header
                  : `${MainQues?.name}`,

              uniqueName: `${modSur?.value}-${MainQues?.name}`,

              total: running_total,

              askOnRef: _askOnRef,

              askOnRefQID: _quesOnRef,

              catTotal: catTotal,

              skip: false,

              visualTotal,

              value: modSur?.value,

              clicked: false,

              response: false,

              buttonText: "Next",

              fr_name:
                MainQues?.use_custom_header && organizationInfo?.custom_survey_header_fr
                  ? organizationInfo?.custom_survey_header_fr
                  : MainQues?.fr_name,

              es_name:
                MainQues?.use_custom_header && organizationInfo?.custom_survey_header_es
                  ? organizationInfo?.custom_survey_header_es
                  : MainQues?.es_name,

              por_name:
                MainQues?.use_custom_header && organizationInfo?.custom_survey_header_por
                  ? organizationInfo?.custom_survey_header_por
                  : MainQues?.por_name,

              // propagate custom header flag from outcome group
              use_custom_header: MainQues?.use_custom_header,

              useScale: mq?.useScale,

              ...(modSur?.value === "feedback_builder"
                ? { allowSkip: mq?.allowSkip }
                : {}),
            });
          });

          _askOnRef = null;

          _quesOnRef = null;

          return null;
        });
      }

      return null;
    });

    // If demographics should appear at the end, insert them now before the submit step

    if (demographicsAtEnd) {
      if (hasCustomCategoryIntro) {
        insertCategoryIntro();
      }

      appendCategoryQuestions();
    }

    // final submit

    running_total += 1;

    total += 1;

    _seq[running_total] = {
      id: running_total,

      quesType: submitTypeQuestion,

      buttonType: submitSurvey,

      buttonText: "Submit",

      skip: false,

      sno: running_total,

      visualTotal,

      clicked: false,

      response: { response: true },
    };

    // const setresetResponsesOnChange = new Set(resetResponsesOnChange);

    setTotalQuestions({
      total: total,

      introQuestion,

      visualTotal,

      runningTotal: running_total,

      introduction: quesLength,

      questions: quesLength,

      category: CatLength, // add primaryCategory

      comments: commLength,

      feedback: feedbackLength,

      sequence: _seq,

      resetResponsesOnChange: resetResponsesOnChange,
    });

    // console.log("question seq ran")
  }, [
    questionList,

    get_brief_response.response.organization_info,

    get_brief_response.modular_questions,

    categoryQues,

    employeeCategory,

    organizationInfo,

    askComments,

    // checkRole removed - now handled reactively by updateSkipLogicForRole

    modSurveyRule,

    showInSurveyPersonality,

    organizationName,
  ]);

  // console.log("currentQuestionDet.id", currentQuestionDet?.id);

  // console.log("totalQuestions", totalQuestions);

  // console.log("questionSequenceMap", questionSequenceMap);

  // console.log("questionSequenceMap", questionSequenceMap[currentQuestionNo]);

  // console.log(

  //   "totalQuestions.resetResponsesOnChange",

  //   totalQuestions.resetResponsesOnChange

  // );

  // console.log(

  //   "totalQuestions?.runningTotal $$$$$$$$$$$$$$$$$$$$$$$$$$$$",

  //   totalQuestions?.runningTotal

  // );

  useEffect(() => {
    // CRITICAL: Read from ref to avoid reading stale state when saveUpdatedAnswers just updated
    const currentMap = questionSequenceMapRef.current || questionSequenceMap;
    
    if (currentQuestionNo > 1 && currentMap) {
      setCurrentQuestionDet(currentMap[currentQuestionNo]);
    } else {
      setCurrentQuestionDet(totalQuestions.sequence[1]);
    }
  }, [questionSequenceMap, currentQuestionNo, totalQuestions]);

  // console.log("currentQuestionNo", currentQuestionNo);

  function nextQuestion() {
    // CRITICAL: Read from ref to get the most up-to-date skip logic and avoid stale state
    const currentMap = questionSequenceMapRef.current || questionSequenceMap;
    let _questionNo = currentQuestionNo + 1;

    while (_questionNo <= totalQuestions?.runningTotal) {
      if (currentMap[_questionNo]?.skip) {
        // console.log("_checkFdbk ++++++++++++ SKIP", currentQuestionNo, _questionNo)

        _questionNo++;
      } else {
        const _checkFdbk = currentMap[_questionNo]?.response?.skip;

        // check if follow up and feedback is skipped

        if (_checkFdbk) {
          // console.log("_checkFdbk ++++++++++++ RESPONSE SKIP", currentQuestionNo, _questionNo)

          _questionNo++;
        } else {
          // console.log("_checkResp ++++++++++++ OK", currentQuestionNo, _questionNo)

          return _questionNo;
        }
      }
    }

    return currentQuestionNo;
  }

  const handleNext = (forced = "") => {
    const timer1 = setTimeout(() => {
      // this whole block is to check if the question is skipped

      // this block checks if the question is skipped

      if (currentQuestionNo) {
        const _currQuestion = questionSequenceMap[currentQuestionNo];

        if (_currQuestion && currentQuestionNo > 1) {
          // Skip the entire block if _currQuestion is skipped or response is skipped or response is empty

          // Continue if any of the specified conditions is true

          if (
            _currQuestion?.skip ||
            _currQuestion.response?.skip ||
            _currQuestion?.response?.clicked ||
            _currQuestion.response?.response !== undefined ||
            forced == "forced"
          ) {
            // console.log("Continue with the code");
            // Continue with the code
          } else {
            // Return from handleNext

            // console.log("Conditions not met - Returning from handleNext");

           

            return;
          }
        }
      }

      // console.log("currentQuestionNo handleNext >>>>>>>>>>>>>>>>>>>>>>>>>> ");

      const NextQues = nextQuestion();

      if (currentQuestionNo < NextQues) {
        setDirection("slide");

        // persist with api

        if (briefResponseId) {
          patchCounterRef.current += 1;
          if (PATCH_EVERY_N <= 1 || (patchCounterRef.current % PATCH_EVERY_N) === 0) {
            dispatch({
              type: SG_UPDATE_BRIEF_RESPONSE,

              payload: {
                id: briefResponseId,

                query: `?token=${token}`,

                validation_token: LOCAL_VALIDATION_TOKEN,

                ...(formPayload && {
                  stored_response: {
                    ...formPayload,

                    validation_token: LOCAL_VALIDATION_TOKEN,
                  },
                }),
              },
            });
          }
        }

        setQuestionNo(NextQues);

        // // setVisualQuestionNo(visualQuestionNo + 1)

        setVisualQuestionNo(questionSequenceMap[NextQues]?.visualTotal);

        // console.log(

        //   "NextQues handleNext ++++++++++++++++++++++++++++++++++++",

        //   NextQues

        // );

        setCurrentQuestionNo(NextQues);
      }
    }, 10);

    // console.log(

    //   "currentQuestionNo handleNext ++++++++^^^^^^^^^^^^^^^^",

    //   currentQuestionNo

    // );

    return () => clearTimeout(timer1);
  };

  function prevQuestion() {
    // CRITICAL: Read from ref to get the most up-to-date skip logic and avoid stale state
    const currentMap = questionSequenceMapRef.current || questionSequenceMap;
    let _questionNo = currentQuestionNo - 1;

   
    while (_questionNo >= 1) {
      const question = currentMap[_questionNo];
      const skipFlag = question?.skip;
      const responseSkip = question?.response?.skip;
      
     

      if (skipFlag) {
        // Skip questions that have skip property true
        _questionNo--;
      } else {
        const _checkFdbk = responseSkip;

        // check if follow up and feedback is skipped

        if (_checkFdbk) {
          _questionNo--;
        } else {
          // Return valid question without setting state
          return _questionNo;
        }
      }
    }

    return currentQuestionNo;
  }

  const handleBack = () => {
    setDisableNext(false);

    if (currentQuestionNo > 0) {
      setDirection("slide-back");

      // persist with api

      const timer1 = setTimeout(() => {
        if (briefResponseId) {
          patchCounterRef.current += 1;
          if (PATCH_EVERY_N <= 1 || (patchCounterRef.current % PATCH_EVERY_N) === 0) {
            dispatch({
              type: SG_UPDATE_BRIEF_RESPONSE,

              payload: {
                id: briefResponseId,

                query: `?token=${token}`,

                validation_token: LOCAL_VALIDATION_TOKEN,

                ...(formPayload && {
                  stored_response: {
                    ...formPayload,

                    validation_token: LOCAL_VALIDATION_TOKEN,
                  },
                }),
              },
            });
          }
        }

        const prevQuesNo = prevQuestion();

        setCurrentQuestionNo(prevQuesNo);

        setQuestionNo(prevQuesNo);

        // CRITICAL: Read from ref to ensure we get the most up-to-date visualTotal
        const currentMap = questionSequenceMapRef.current || questionSequenceMap;
        setVisualQuestionNo(currentMap[prevQuesNo]?.visualTotal);
      }, 10);

      return () => clearTimeout(timer1);
    }
  };

  function resetValidationToken(newValidationToken) {
    LOCAL_VALIDATION_TOKEN = newValidationToken;
  }

  // console.log(formPayload)

  useEffect(() => {
    if (get_brief_response?.response?.id) {
      setNoResponse(false);
    } else {
      setNoResponse(true);
    }
  }, [get_brief_response]);

  useEffect(() => {
    if (get_brief_response?.response.length == 0) {
      return;
    }

    let EmpPrimary = get_brief_response?.response?.employee_category.find(
      (ec) => ec?.priority === "primary"
    )?.value;

    const primaryFrench =
      get_brief_response?.response?.primary_question[0]?.options?.find(
        (f) => f.name == EmpPrimary
      )?.fr;

    if (language == "FR" && primaryFrench) {
      EmpPrimary = primaryFrench;
    }

    setTeamName(EmpPrimary);

    if (get_brief_response?.response?.organization_info?.organization == 2) {
      setOrganizationName(`${EmpPrimary}`);
    } else {
      setOrganizationName(
        `${get_brief_response?.response?.organization_name} - ${EmpPrimary}`
      );
    }
  }, [language]);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setDelayedShow(get_brief_response?.pending);
    }, 1000);

    return () => clearTimeout(timer1);
  }, [get_brief_response]);

  // console.log("OR", get_brief_response?.pending | get_modular_questions?.pending)

  // console.log("AND", get_brief_response?.pending & get_modular_questions?.pending)

  useEffect(() => {
    // Run! Like go get some data from an API.

    if (token) {
      dispatch({
        type: SG_START_BRIEF_SURVEY,

        payload: `?token=${token}`,
      });
    }
  }, [dispatch, token]);

  //Logic to handle question variants

  // Add this helper function with bulletproof error handling

  const getCurrentCategoryUIDs = () => {
    try {
      const currentUIDs = questionAnswers?.categories
        ? Object.values(questionAnswers.categories)

            .filter((answer) => {
              try {
                return (
                  answer &&
                  answer.response &&
                  typeof answer.response === "string"
                );
              } catch {
                return false;
              }
            })

            .map((answer) => {
              try {
                return answer.response;
              } catch {
                return null;
              }
            })

            .filter(Boolean)
        : [];

      const initialUIDs = Array.isArray(employeeCategory)
        ? employeeCategory

            .map((cat) => {
              try {
                return cat && cat.value_id && typeof cat.value_id === "string"
                  ? cat.value_id
                  : null;
              } catch {
                return null;
              }
            })

            .filter(Boolean)
        : [];

      return [...new Set([...currentUIDs, ...initialUIDs])];
    } catch (error) {
      // If anything fails, return empty array - variants will be ignored

      console.warn(
        "Variant processing: Failed to get category UIDs, falling back to no variants:",
        error
      );

      return [];
    }
  };

  // Reactive skip logic updater: updates existing questionSequenceMap without rebuilding
  const updateSkipLogicForRole = () => {
    // CRITICAL: Read from ref to get the most up-to-date state and avoid race conditions
    const currentMap = questionSequenceMapRef.current;
    
    if (!currentMap || !questionList) {
      return;
    }

    const _empCat = getCurrentCategoryUIDs();
    const updatedMap = { ...currentMap };
    let hasChanges = false;

    // Iterate through the sequence and update skip flags for role-based questions
    Object.keys(updatedMap).forEach((key) => {
      const questionInSeq = updatedMap[key];
      
      // Only process questions of type questionTypeQuestion
      if (questionInSeq?.quesType === questionTypeQuestion && questionInSeq?.quesListNo) {
        // Find the original question from questionList to get its role property
        const originalQuestion = questionList.filter(
          (q) => q.order === questionInSeq.quesListNo
        )[0];
        
        // Check if this question has role-based skip logic
        if (originalQuestion?.role) {
          const shouldSkip = hasMatch(originalQuestion.role, _empCat) ? false : true;
          
          // Only update if skip status actually changed
          if (questionInSeq.skip !== shouldSkip) {
            updatedMap[key] = {
              ...questionInSeq,
              skip: shouldSkip,
            };
            hasChanges = true;
          }
        }
      }
    });

    // Only update state if there were actual changes
    if (hasChanges) {
      // Apply skip logic to handle feedback/follow-up cascades
    const { newRuleFeedback, updated: mapWithSkipLogic } = applySkipLogic(questionAnswers, updatedMap, surveyFeedbackResp);
      
      questionSequenceMapRef.current = mapWithSkipLogic;
      setQuestionSequenceMap(mapWithSkipLogic);
      setRuleFeedback(newRuleFeedback);
    }
  };

  // Update the applyQuestionVariants to work with individual questions with bulletproof error handling

  const getQuestionWithVariant = (question, categoryUIDs) => {
    // CRITICAL: Always return the original question if ANYTHING goes wrong

    try {
      // Early returns for safety

      if (!question || typeof question !== "object") {
        return question;
      }

      if (!question.variants || typeof question.variants !== "object") {
        return question;
      }

      if (!Array.isArray(categoryUIDs) || categoryUIDs.length === 0) {
        return question;
      }

      // Safe variant matching with comprehensive error handling

      let matchingVariant = null;

      try {
        const variantEntries = Object.entries(question.variants);

        matchingVariant = variantEntries.find(([uid, variant]) => {
          try {
            // Ensure uid is a string and variant is an object

            if (
              typeof uid !== "string" ||
              !variant ||
              typeof variant !== "object"
            ) {
              return false;
            }

            return categoryUIDs.includes(uid);
          } catch {
            return false;
          }
        });
      } catch (error) {
        console.warn(
          "Variant processing: Failed to find matching variant, using original question:",
          error
        );

        return question;
      }

      if (!matchingVariant) {
        return question;
      }

      const [uid, variant] = matchingVariant;

      // Safely apply variant with fallbacks

      try {
        return {
          ...question,

          // Only update text fields if they exist and are strings, otherwise use original

          question:
            variant.q && typeof variant.q === "string"
              ? variant.q
              : question.question,

          fr:
            variant.fr && typeof variant.fr === "string"
              ? variant.fr
              : question.fr,

          es:
            variant.es && typeof variant.es === "string"
              ? variant.es
              : question.es,

          por:
            variant.por && typeof variant.por === "string"
              ? variant.por
              : question.por,

          appliedVariant: uid,

          // CRITICAL: Explicitly preserve all structural data to prevent response mapping issues

          order: question.order,

          dimension: question.dimension,

          factor: question.factor,

          q: question.q,

          role: question.role,

          reverse: question.reverse,

          title: question.title,

          qualifier: question.qualifier,

          scale: question.scale,

          allowSkip: question.allowSkip,

          importance: question.importance || null,
        };
      } catch (error) {
        console.warn(
          "Variant processing: Failed to apply variant, using original question:",
          error
        );

        return question;
      }
    } catch (error) {
      // If ANYTHING goes wrong, return the original question

      console.warn(
        "Variant processing: Critical error in getQuestionWithVariant, using original question:",
        error
      );

      return question;
    }
  };

  // console.log("surveyModularResp", surveyModularResp)

  // final submit

  function submitAnswer() {
    const CompleteCategories = {
      ...questionAnswers?.categories,

      ...prevFoundResponse,

      ...neverAskResponse,
    };

    if (CompleteCategories) {
      CompleteCategories[0] = primaryCategory;
    }

    // Count only non-skipped questions that should be answered

    if (totalQuestions?.questions && questionAnswers?.questions) {
      const nonSkippedQuestionCount = Object.values(
        questionSequenceMap || {}
      ).filter((q) => q.quesType === questionTypeQuestion && !q.skip).length;

      if (
        nonSkippedQuestionCount >
        Object.values(questionAnswers?.questions).length
      ) {
        // console.log("error found")

        setSubmitError(ERROR_ON_SUBMISSION);

        return;
      }
    }

    let _completeCategories = [];

    if (CompleteCategories) {
      _completeCategories = Object.values(CompleteCategories);
    }

    let _completeQuestions = [];

    if (questionAnswers.questions) {
      _completeQuestions = Object.values(questionAnswers.questions);
    }

    let _completeComments = [];

    if (questionAnswers.comments) {
      _completeComments = Object.values(questionAnswers.comments);
    }

    // console.log( {

    //   			questions: {

    //   				questions: _completeQuestions,

    //   				categories: _completeCategories,

    //   				comments: _completeComments,

    //   			},

    //   			total_question_map: totalQuestions,

    //   			feedback: surveyFeedbackResp,

    //   			survey_personality: surveyPersonalityResp,

    //   			modular_response: surveyModularResp,

    //   			version: 2.0,

    //   			version_description: "Culture Audit version which includes revised chat gpt and home list of all questions",

    //   		})

    dispatch({
      type: SG_POST_BRIEF_RESPONSE,

      payload: {
        survey_token: briefResponse?.survey_token,

        debrief_schedule: briefResponse?.debrief_schedule,

        employee: briefResponse?.employee,

        validation_token: null,

        response: {
          questions: {
            questions: _completeQuestions,

            categories: _completeCategories,

            comments: _completeComments,
          },

          total_question_map: totalQuestions,

          feedback: surveyFeedbackResp,

          survey_personality: surveyPersonalityResp,

          modular_response: surveyModularResp,

          version: 2.0,

          version_description:
            "Culture Audit version which includes revised chat gpt and home list of all questions",
        },

        full_response: {
          isBrowser: isBrowser,

          isMobile: isMobile,

          browser: deviceDetected.browserName,

          deviceType,

          osVersion,

          osName,

          deviceDetected: deviceDetected,

          response: {
            questions: {
              questions: _completeQuestions,

              categories: _completeCategories,

              comments: _completeComments,
            },

            total_question_map: totalQuestions,

            feedback: surveyFeedbackResp,

            survey_personality: surveyPersonalityResp,

            modular_response: surveyModularResp,

            version: 2.0,

            version_description:
              "Culture Audit version which includes revised chat gpt and home list of all questions",
          },
        },
      },
    });

    dispatch({
      type: RESET_VALIDATION_TOKEN,

      payload: null,
    });

    dispatch({
      type: CLEAR_ALL,

      payload: null,
    });

    localStorage.clear();

    setSurveyFinished(true);
  }

  function StartSurvey() {
    const _questionSequenceMap = totalQuestions?.sequence;

    _questionSequenceMap[currentQuestionNo].clicked = true;

    _questionSequenceMap[currentQuestionNo].response = true;

    let NewValidationToken = uuidv4();

    if (LOCAL_VALIDATION_TOKEN) {
      NewValidationToken = LOCAL_VALIDATION_TOKEN;
    } else {
      localStorage.setItem("validation_token", NewValidationToken);
    }

    setFormPayload({
      current_question: 1,

      current_answer: 0,

      high_answer: 0,

      answers: {
        categories: {},

        questions: {},

        comments: {},
      },

      complete: false,

      intro_completed: true,

      modular_response: {},

      survey_personality: {},

      feedback: [],

      questionSequenceMap: _questionSequenceMap,

      validation_token: NewValidationToken,
    });

    dispatch({
      type: NEW_VALIDATION_TOKEN,

      payload: NewValidationToken,
    });

    questionSequenceMapRef.current = _questionSequenceMap;
    setQuestionSequenceMap(_questionSequenceMap);

    handleNext();
  }

  // console.log("get_brief_response?.feedback", get_brief_response?.feedback)

  // console.log("get_brief_response?.survey_personality", get_brief_response?.survey_personality)

  // console.log("get_brief_response?.modular_response", get_brief_response?.modular_response)

  // console.log("get_brief_response?.answers", get_brief_response?.answers)

  // console.log("currentQuestionNo", currentQuestionNo)

  // console.log("currentQuestionDet", currentQuestionDet)

  // console.log("surveyModularResp", surveyModularResp)

  // console.log("categoryQues", categoryQues)

  // updated answers

  function saveUpdatedAnswers(curQuesNo, response, typeOf) {
    // console.log("saveUpdatedAnswers" ,curQuesNo, response, typeOf)

    let _feedbackResp = [];

    if (surveyFeedbackResp) {
      _feedbackResp = surveyFeedbackResp;
    }

    const _questionAnswers = questionAnswers;

    let _survey_personality = {};

    if (surveyPersonalityResp) {
      _survey_personality = surveyPersonalityResp;
    }

    let _modular_response = {};

    if (surveyModularResp) {
      _modular_response = surveyModularResp;
    }

    // CRITICAL: Read from ref to ensure we're working with the most up-to-date map
    const currentMap = questionSequenceMapRef.current || questionSequenceMap;
    const _curQuesDet = currentMap[curQuesNo];

    

    // Early exit for standard question type when value is unchanged or invalid
    if (typeOf === questionTypeQuestion) {
      const prevEntry = _questionAnswers?.questions?.[curQuesNo];
      const prevResp = prevEntry?.response;
      const prevClicked = prevEntry?.clicked;
      const prevSkip = prevEntry?.skip;

      const nextResp = response?.response;
      const nextClicked =
        typeof response?.clicked === "boolean" ? response.clicked : true;
      const nextSkip = response?.skip;

      const respChanged = prevResp !== nextResp;
      const clickedChanged = prevClicked !== nextClicked;
      const skipChanged = prevSkip !== nextSkip;

      // CRITICAL: Even if questionAnswers hasn't changed, we must update questionSequenceMap
      // because the map might be stale from other effects. Only exit if BOTH are unchanged.
      const mapResponse = currentMap[curQuesNo]?.response?.response;
      const mapClicked = currentMap[curQuesNo]?.clicked;
      const mapNeedsUpdate = mapResponse !== nextResp || mapClicked !== nextClicked;

      if (!respChanged && !clickedChanged && !skipChanged && !mapNeedsUpdate) {
        return; // nothing meaningful changed
      }

      if (response && typeof response === "object") {
        response.clicked = nextClicked;
      }
    }

    if (typeOf === categoryTypeQuestion) {
      _questionAnswers.categories[curQuesNo] = response;
    }

    if (typeOf === questionTypeQuestion) {
      _questionAnswers.questions[curQuesNo] = response;
    }

    if (typeOf === commentTypeQuestion) {
      _questionAnswers.comments[curQuesNo] = response;
    }

    if (typeOf === feedbackTypeQuestion) {
      _feedbackResp = _feedbackResp.filter(
        (fb) => fb?.survey_q_id !== response?.survey_q_id
      );

      _feedbackResp.push(response);
    }

    if (typeOf === followupAiTypeQuestion) {
      _feedbackResp = _feedbackResp.filter(
        (fb) => fb?.survey_q_id !== response?.survey_q_id
      );

      _feedbackResp.push(response);
    }

    if (typeOf === personalityTypeQuestion) {
      _survey_personality[_curQuesDet?.perListNo] = response;
    }

    // console.log("modularOutcomeTypeQuestion", modularOutcomeTypeQuestion)

    if (typeOf === modularOutcomeTypeQuestion) {
      //   console.log(response)

      const modularQuestion = get_brief_response?.surveyComponents.find(
        (sc) => sc.value === _curQuesDet?.value
      );

      if (_modular_response[_curQuesDet?.value]?.responses) {
        let _modResps = _modular_response[_curQuesDet?.value]?.responses;

        // match ques_order

        _modResps = _modResps.filter(
          (fb) => fb?.ques_order !== _curQuesDet?.id
        );

        _modResps.push(response);

        _modular_response[_curQuesDet?.value].responses = _modResps;
      } else {
        _modular_response[_curQuesDet?.value] = {
          id: modularQuestion?.id,

          label: modularQuestion?.name,

          value: modularQuestion?.value,

          on_date: new Date(),

          ask_again: 2,

          completed: true,

          responses: [response],

          briefResponseId: get_brief_response?.id,

          brief_schedule_id: get_brief_response?.debrief_schedule,
        };
      }

      //   console.log("modularQuestion", modularQuestion)
    }

    // console.log("_feedbackResp", _feedbackResp)

    if (typeOf === modularValuesTypeQuestion) {
      const modularQuestion = get_brief_response?.surveyComponents.find(
        (sc) => sc.value === _curQuesDet?.value
      );

      if (_modular_response[_curQuesDet?.value]?.responses) {
        let _modResps = _modular_response[
          _curQuesDet?.value
        ]?.responses?.filter((fb) => fb?.ques_order !== _curQuesDet?.id);

        // match ques_order

        _modResps.push(response);

        _modular_response[_curQuesDet?.value].responses = _modResps;
      } else {
        _modular_response[_curQuesDet?.value] = {
          id: modularQuestion?.id,

          label: modularQuestion?.name,

          value: modularQuestion?.value,

          on_date: new Date(),

          ask_again: 2,

          completed: true,

          responses: [response],

          briefResponseId: get_brief_response?.id,

          brief_schedule_id: get_brief_response?.debrief_schedule,
        };
      }
    }

    if (
      typeOf === modularCommentTypeQuestion ||
      typeOf === modularSelectCommentTypeQuestion
    ) {
      const modularQuestion = get_brief_response?.surveyComponents.find(
        (sc) => sc.value === _curQuesDet?.value
      );

      if (_modular_response[_curQuesDet?.value]?.responses) {
        let _modResps = _modular_response[
          _curQuesDet?.value
        ]?.responses?.filter((fb) => fb?.ques_order !== _curQuesDet?.id);

        // match ques_order

        _modResps.push(response);

        _modular_response[_curQuesDet?.value].responses = _modResps;
      } else {
        _modular_response[_curQuesDet?.value] = {
          id: modularQuestion?.id,

          label: modularQuestion?.name,

          value: modularQuestion?.value,

          on_date: new Date(),

          ask_again: 2,

          completed: true,

          responses: [response],

          briefResponseId: get_brief_response?.id,

          brief_schedule_id: get_brief_response?.debrief_schedule,
        };
      }
    }

    // multiAiFollowupCommentQuestion

    if (typeOf === multiAiFollowupCommentQuestion) {
      const modularQuestion = get_brief_response?.surveyComponents.find(
        (sc) => sc.value === _curQuesDet?.value
      );

      if (_modular_response[_curQuesDet?.value]?.responses) {
        let _modResps = _modular_response[
          _curQuesDet?.value
        ]?.responses?.filter((fb) => fb?.ques_order !== _curQuesDet?.id);

        // match ques_order

        _modResps.push(response);

        _modular_response[_curQuesDet?.value].responses = _modResps;
      } else {
        _modular_response[_curQuesDet?.value] = {
          id: modularQuestion?.id,

          label: modularQuestion?.name,

          value: modularQuestion?.value,

          on_date: new Date(),

          ask_again: 2,

          completed: true,

          responses: [response],

          briefResponseId: get_brief_response?.id,

          brief_schedule_id: get_brief_response?.debrief_schedule,
        };
      }

      dispatch({
        type: CLEAR_CHAT_GPT_SUMMARY,
      });
    }

    let _complete = false;

    if (curQuesNo + 1 >= totalQuestions.visualTotal) {
      _complete = true;
    }

    setQuestionAnswers(_questionAnswers);

    setSurveyPersonalityResp(_survey_personality);

    setSurveyFeedbackResp(_feedbackResp);

    const responseClicked =
      typeof response?.clicked === "boolean" ? response.clicked : true;

    // CRITICAL: Build from currentMap (ref) to preserve the most up-to-date skip logic
    const newSequence = {
      ...currentMap, // ① new map ref

      [curQuesNo]: {
        ...currentMap[curQuesNo], // ② new nested ref

        clicked: responseClicked,

        response: response,
      },
    };

    

    const { updated: new_sequence } = applySkipLogic(
      _questionAnswers,
      newSequence,
      _feedbackResp
    );

    

    // Ensure MultiFollowUp is correctly skipped/un-skipped when its related input changes
    // Applies to both free-text comments and single-select feedback (feedback_builder select)

    let final_sequence = new_sequence;

    if (
      typeOf === modularCommentTypeQuestion ||
      typeOf === modularSelectCommentTypeQuestion
    ) {
      const value = response?.response;

      const isString = typeof value === "string";

      const isMeaningfulString =
        isString &&
        value.trim().length > 0 &&
        value !== "N/A" &&
        value !== "SKIP";

      const isExplicitSkipFlag = response?.skip === true; // covers auto-skip cases

      const isInvalidOrSkipped = !isMeaningfulString || isExplicitSkipFlag;

      const updatedMap = { ...final_sequence };
      const prevValue = (currentMap?.[curQuesNo]?.response || {}).response;
      const didChange = prevValue !== value;
      try {
        // eslint-disable-next-line no-console
        console.log('[SkipLogic] referenced input change check', { curQuesNo, prevValue, nextValue: value, didChange });
      } catch {}

      Object.keys(updatedMap).forEach((key) => {
        const q = updatedMap[key];

        const referencesThisInput =
          Array.isArray(q?.followUpQuestions) &&
          q.followUpQuestions.includes(curQuesNo);

        if (
          q?.quesType === multiAiFollowupCommentQuestion &&
          referencesThisInput
        ) {
          const existingResp = q.response || {};

          if (isMeaningfulString && existingResp.skip) {
            // Unskip when input becomes a valid non-N/A selection or non-blank text

            updatedMap[key] = {
              ...q,

              response: { ...existingResp, skip: false },
            };
          }

          if (isInvalidOrSkipped) {
            // Proactively (re)skip when input is blank, N/A/SKIP, or flagged skip; clear stale GPT fields

            updatedMap[key] = {
              ...q,

              response: {
                ...existingResp,
                skip: true,
                prompt: "",
                prompt_question: "",
                response: "",
                question: "",
              },
            };
          }

          // For valid inputs, only request regeneration when the referenced input actually changed
          if (didChange && isMeaningfulString && !isInvalidOrSkipped) {
            updatedMap[key] = {
              ...q,
              response: {
                ...existingResp,
                skip: false,
                prompt: "",
                prompt_question: "",
                question: "",
                response: "",
                clicked: false,
              },
            };
            try {
              // eslint-disable-next-line no-console
              console.log('[SkipLogic] cleared follow-up due to input change', { followUpKey: key, ref: curQuesNo });
            } catch {}
          }
        }
      });

      final_sequence = updatedMap;
    }

    // Update ref synchronously for immediate button state access
    questionSequenceMapRef.current = final_sequence;
    setQuestionSequenceMap(final_sequence);
    
    // CRITICAL: Also update currentQuestionDet immediately to ensure button state is correct
    // This prevents race conditions where other effects might overwrite with stale data
    if (curQuesNo === currentQuestionNo) {
      setCurrentQuestionDet(final_sequence[curQuesNo]);
    }

    setFormPayload({
      visual_question: _curQuesDet?.visualTotal,

      current_question: curQuesNo,

      current_answer: curQuesNo,

      high_answer:
        curQuesNo > briefResponse?.high_answer
          ? curQuesNo
          : briefResponse?.high_answer,

      answers: _questionAnswers,

      complete: _complete,

      validation_token: LOCAL_VALIDATION_TOKEN,

      survey_personality: _survey_personality,

      modular_response: _modular_response,

      questionSequenceMap: final_sequence,

      feedback: _feedbackResp,
    });

    setSurveyModularResp(_modular_response);

    if (askNextQuestion) {
      const nextKey = curQuesNo + 1;
      // Use the latest map from the ref to avoid overwriting just-saved answers with stale state
      const latestMap = questionSequenceMapRef.current || questionSequenceMap;
      const nextQ = latestMap[nextKey];

      const isAiFollowUp =
        nextQ?.quesType === followupAiTypeQuestion ||
        nextQ?.quesType === multiAiFollowupCommentQuestion;

      if (isAiFollowUp && nextQ?.response) {
        const existingResp = nextQ.response || {};

        const updatedMap = {
          ...latestMap,
          [nextKey]: {
            ...nextQ,
            response: {
              ...existingResp,
              prompt: null,
              prompt_question: null,
              feedback: null,
              skipped: false,
            },
          },
        };

        

        questionSequenceMapRef.current = updatedMap;
        setQuestionSequenceMap(updatedMap);
      }
    }
  }

  // Sync totalQuestions.sequence with questionSequenceMap on initial build or major structure changes
  // This useEffect now only handles initial setup and major rebuilds (not checkRole changes)
  useEffect(() => {
    // Only sync if we have a new sequence from the builder
    if (totalQuestions.sequence && Object.keys(totalQuestions.sequence).length > 0) {
      // CRITICAL: Always read from ref to avoid race conditions with user input
      const currentMap = questionSequenceMapRef.current;
      
      // If no existing map, this is initial setup - use the sequence as-is
      if (!currentMap) {
        questionSequenceMapRef.current = totalQuestions.sequence;
        setQuestionSequenceMap(totalQuestions.sequence);
        return;
      }

      // For rebuilds (other dependencies changed), preserve user responses from ref
      const mergedSequence = { ...currentMap };

      Object.keys(totalQuestions.sequence).forEach((key) => {
        const oldQuestion = mergedSequence[key];
        const newQuestion = totalQuestions.sequence[key];

        if (oldQuestion) {
          // CRITICAL: Preserve responses, clicked state, skip flags, AND ruleMeta during structure rebuilds
          // Skip flags and ruleMeta are set by applySkipLogic and must not be lost during sequence rebuilds
          // BULLETPROOF: never_ask questions are structurally always-skipped — trust newQuestion.skip
          // unconditionally so a stale oldQuestion.skip can never re-surface them.
          const isNeverAsk = newQuestion?.from?.startsWith("never_ask");
          mergedSequence[key] = {
            ...newQuestion,
            response: oldQuestion.response,
            clicked: oldQuestion.clicked,
            skip: isNeverAsk
              ? true
              : oldQuestion.skip !== undefined
              ? oldQuestion.skip
              : newQuestion.skip,
            ruleMeta: oldQuestion.ruleMeta !== undefined ? oldQuestion.ruleMeta : newQuestion.ruleMeta,
          };
        } else {
          // New question added to sequence
          mergedSequence[key] = newQuestion;
        }
      });

      questionSequenceMapRef.current = mergedSequence;
      setQuestionSequenceMap(mergedSequence);
    }
  }, [totalQuestions.sequence]);

  useEffect(() => {
    if (get_errors?.errors?.error?.request?.response) {
      let RESP = JSON.parse(get_errors?.errors?.error?.request?.response);

      setSubmitError(RESP?.detail);
    }
  }, [get_errors]);

  // console.log(direction)

  function skipNextQuestion() {
    console.log(
      "skipNextQuestion ++++++++++++++++++++++++++++++++++++ *************************"
    );

    setDirection("slide");

    const _refQues = questionSequenceMap[currentQuestionNo];

    const _curQues = questionSequenceMap[currentQuestionNo + 1];

    let ResponseObj = {
      survey_q_id: _curQues.id,

      dimension: _refQues?.response?.dimension,

      factor: _refQues?.response?.factor,

      fr: _refQues?.response?.fr,

      es: _refQues?.response?.es,

      por: _refQues?.response?.por,

      id: _refQues?.response?.id,

      q: _refQues?.response?.q,

      ques_order: _refQues?.response?.ques_order,

      question: _refQues?.response?.question,

      // response: _refQues?.response?.feedback,

      reverse: _refQues?.response?.reverse,

      role: _refQues?.response?.role,

      type: _refQues?.response?.type,

      // prompt: "skipped",

      // prompt_question: "skipped",

      // feedback: '',

      skipped: true,
    };

    let _questionNo = currentQuestionNo + 2;

    saveUpdatedAnswers(_curQues.id, ResponseObj, followupAiTypeQuestion);

    // setCurrentQuestionDet(questionSequenceMap[_questionNo])

    setCurrentQuestionNo(_questionNo);

    setQuestionNo(_questionNo);

    setVisualQuestionNo(questionSequenceMap[_questionNo]?.visualTotal);

    if (currentQuestionNo < _questionNo) {
      // persist with api

      if (briefResponseId) {
        patchCounterRef.current += 1;
        if (PATCH_EVERY_N <= 1 || (patchCounterRef.current % PATCH_EVERY_N) === 0) {
          dispatch({
            type: SG_UPDATE_BRIEF_RESPONSE,

            payload: {
              id: briefResponseId,

              query: `?token=${token}`,

              validation_token: LOCAL_VALIDATION_TOKEN,

              ...(formPayload && { stored_response: formPayload }),
            },
          });
        }
      }
    }
  }

  // console.log(currentQuestionDet)

  const renderModule = (currentQuestionDet) => {
    const currentCategoryUIDs = getCurrentCategoryUIDs();

    switch (currentQuestionDet?.quesType) {
      case introductionTypeQuestion:
        return (
          <Introduction
            id={currentQuestionDet.intro_id}
            currentQuestion={currentQuestionNo}
            total={currentQuestionDet.total}
            language={language}
            ai_disclaimer={organizationInfo?.ai_disclaimer}
            sort_order={currentQuestionDet?.survey_sort_order}
            disableNext={(v) => setDisableNext(v)}
            intro_type={currentQuestionDet?.intro_type}
            organizationInfo={organizationInfo}
            title={
              organizationInfo?.intro_title
                ? get_brief_response?.response?.organization_name
                : false
            }
          />
        );

      case customIntroTypeQuestion:
        return (
          <CustomIntro
            id={currentQuestionDet.intro_id}
            contents={currentQuestionDet.contents}
            language={language}
            disableNext={(v) => setDisableNext(v)}
          />
        );

      case categoryTypeQuestion:
        return (
          <Categories
            question={currentQuestionDet.question}
            categories={currentQuestionDet.categories}
            description={currentQuestionDet.description}
            categoryQues={categoryQues}
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            organizationName={organizationName}
            organizationInfo={organizationInfo}
            customHeader={customHeader}
            custom_title={
              get_brief_response?.response?.questions?.category_titles
            }
            // existingResponse={existingResponse}

            // employeeCategory={employeeCategory}

            language={language}
            public_intro={organizationInfo?.public_intro}
            custom_thanks={
              get_brief_response?.response?.questions?.custom_thanks
            }
            custom_category_intro={
              get_brief_response?.response?.questions?.custom_category_intro
            }
          />
        );

      case questionTypeQuestion:
        const originalQuestion = questionList.filter(
          (q) => q.order === currentQuestionDet?.quesListNo
        )[0];

        // Apply variant just-in-time

        const questionWithVariant = getQuestionWithVariant(
          originalQuestion,
          currentCategoryUIDs
        );

        return (
          <Question
            question={questionWithVariant}
            saveUpdatedAnswers={saveUpdatedAnswers}
            currentQuestionDet={currentQuestionDet}
            language={language}
            qualifier={organizationInfo?.survey_qualifier}
            fr_qualifier={organizationInfo?.survey_qualifier_fr}
            team_qualifier={organizationInfo?.team_qualifier}
            teamName={teamName}
            organizationInfo={organizationInfo}
            useLikert={organizationInfo?.useLikert}
            customHeader={customHeader}
          />
        );

      case commentTypeQuestion:
        return (
          <Comments
            data={currentQuestionDet}
            question={
              askComments.filter(
                (q) => q.id === currentQuestionDet?.comListNo
              )[0]
            }
            saveUpdatedAnswers={saveUpdatedAnswers}
            currentQuestionDet={currentQuestionDet}
            language={language}
            organizationInfo={organizationInfo}
            customHeader={customHeader}
          />
        );

      case feedbackTypeQuestion:
        // AI feedback question ln 1188

        return (
          <Feedback
            ruleFeedback={
              questionSequenceMap?.[currentQuestionDet?.id]?.ruleMeta ||
              ruleFeedback[currentQuestionDet?.feedListNo - 1]
            }
            saveUpdatedAnswers={saveUpdatedAnswers}
            currentQuestionDet={currentQuestionDet}
            language={language}
            skipNextQuestion={skipNextQuestion}
            setAskNextQuestion={setAskNextQuestion}
            sortOrder={sortOrder}
            useLikert={organizationInfo?.useLikert}
          />
        );

      case followupAiTypeQuestion:
        // AI chat gpt follow up question for max -min feedback only

        // console.log(currentQuestionDet)

        const refFollowUpQues =
          questionSequenceMap[currentQuestionDet?.quesRefId];
          
        return (
          <FollowUp
            currentQuestionDet={currentQuestionDet}
            refQues={refFollowUpQues}
            saveUpdatedAnswers={saveUpdatedAnswers}
            handleNext={handleNext}
            language={language}
            sortOrder={sortOrder}
          />
        );

      case personalityTypeQuestion:
        return (
          <PersonalityChoice
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            language={language}
          />
        );

      case modularOutcomeTypeQuestion:
        return (
          <QuestionModular
            resetResponsesOnChange={totalQuestions?.resetResponsesOnChange}
            questionSequenceMap={questionSequenceMap}
            question={currentQuestionDet?.question}
            saveUpdatedAnswers={saveUpdatedAnswers}
            currentQuestionDet={currentQuestionDet}
            language={language}
            teamName={teamName}
            useLikert={organizationInfo?.useLikert}
            organizationInfo={organizationInfo}
            customHeader={customHeader}
          />
        );

      case modularValuesTypeQuestion:
        // question, saveUpdatedAnswers, currentQuestionDet

        return (
          <QuestionValues
            question={currentQuestionDet?.question}
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            language={language}
          />
        );

      case modularCommentTypeQuestion:
        return (
          <QuestionComments
            questionSequenceMap={questionSequenceMap}
            direction={direction}
            handleNext={handleNext}
            handleBack={handleBack}
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            language={language}
            customHeader={customHeader}
          />
        );

      case modularSelectCommentTypeQuestion:
        return (
          <SingleSelectFeedback
            questionSequenceMap={questionSequenceMap}
            direction={direction}
            handleNext={handleNext}
            handleBack={handleBack}
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            language={language}
            customHeader={customHeader}
          />
        );

      case multiAiFollowupCommentQuestion:
        // AI multi follow up

        return (
          <MultiFollowUp
            localToken={LOCAL_VALIDATION_TOKEN}
            questionSequenceMap={questionSequenceMap}
            currentQuestionDet={currentQuestionDet}
            saveUpdatedAnswers={saveUpdatedAnswers}
            direction={direction}
            handleNext={handleNext}
            handleBack={handleBack}
            language={language}
          />
        );

      case introSectionTypeQuestion:
        return <IntroSection data={currentQuestionDet} />;

      // incase the survey was completed earlier or token's missing or something

      // case completedTypeQuestion:

      //   return <Completed title={storedTitle} language={language}/>;

      case submitTypeQuestion:
        return <Submit language={language} />;

      default:
        return null;
    }
  };

  if (delayedShow) {
    return (
      <ModuleContainer className="module-wrapper" key={currentQuestionNo}>
        <LogoAnimation />
      </ModuleContainer>
    );
  }

  if (surveyFinished) {
    const endScreens = endScreensPersisted.length
      ? endScreensPersisted
      : normalizeEndScreens(get_brief_response?.response);

    return (
      <ModuleContainer
        className="module-wrapper"
        key={currentQuestionNo}
        height={height}
        style={{ paddingBottom: 0 }}
        endScreen={true}
      >
        {hasEndScreens(endScreens) ? (
          <EndScreens
            screens={endScreens}
            language={language}
            onComplete={() => {}}
          />
        ) : (
          <Completed
            statusText={THANKYOU_MESSAGE[language]}
            title={storedTitle}
            language={language}
            whitelabel={organizationInfo}
          />
        )}
      </ModuleContainer>
    );
  }

  if (surveyDeleted) {
    return (
      <ModuleContainer className="module-wrapper" key={currentQuestionNo}>
        <Completed
          statusText={words["completed_on"][language]}
          completedOn={surveyDeletedOn}
          language={language}
          surveyStatus={surveyStatus}
          title={storedTitle}
          fr_title={organizationInfo?.custom_survey_header_fr}
        />
      </ModuleContainer>
    );
  }

  // // ask for existing data in storage

  if (currentQuestionNo > 1 && storedResponseFound) {
    return (
      <AuditExistingDataFound
        setQuestionNo={setQuestionNo}
        setVisualQuestionNo={setVisualQuestionNo}
        token={token}
        briefResponseId={briefResponseId}
        resetValidationToken={resetValidationToken}
        storedResponseFound={storedResponseFound}
        storedResponse={storedResponse}
        setCurrentQuestionNo={setCurrentQuestionNo}
        setCurrentQuestionDet={setCurrentQuestionDet}
        setQuestionSequenceMap={setQuestionSequenceMap}
        setShowingStoredResponse={setShowingStoredResponse}
        language={language}
        questionSequenceMapRef={questionSequenceMapRef}
      />
    );
  }

  if (!token | !get_brief_response.id | noResponse) {
    return (
      <ModuleContainer className="module-wrapper" key={currentQuestionNo}>
        <Completed
          statusText={MISSING_OR_INVALID_TOKEN}
          language={language}
          title={false}
          whitelabel={organizationInfo}
        />
      </ModuleContainer>
    );
  }

  return (
    <SurveyContainer topPadding={topBarHeight}>
      <TopBar ref={topBarRef}>
        {/* progress bar when it not introduction */}

        {currentQuestionNo > totalQuestions?.introQuestion &&
          !surveyFinished && (
            <ProgressBar
              currentQuestion={currentQuestionDet?.visualTotal}
              totalQuestions={totalQuestions?.visualTotal}
              quesId={currentQuestionDet?.id}
              language={language}
              color={organizationInfo?.progress_bar}
              color2={organizationInfo?.progress_bar2}
            />
          )}

        {/* back button to take one question back when it not introduction */}

        {currentQuestionNo > 1 &&
          currentQuestionNo <= totalQuestions?.introQuestion && (
            <Back onClick={handleBack}>
              <Icon name="chevron left" />{" "}
            </Back>
          )}

        {showLanguage && (
          <Language
            language={language}
            setLanguage={setLanguage}
            languages={languages}
          />
        )}
      </TopBar>

      <ModuleContainer
        className="module-wrapper"
        selected={currentQuestionDet?.quesType}
        key={currentQuestionNo}
        height={height}
      >
        {renderModule(currentQuestionDet)}
      </ModuleContainer>

      <ButtonContainer>
        <NavigationButtons
          introQuestion={totalQuestions?.introQuestion}
          currentQuestionDet={currentQuestionDet}
          questionSequenceMapRef={questionSequenceMapRef}
          currentQuestionNo={currentQuestionNo}
          handleBack={handleBack}
          handleNext={handleNext}
          surveyFinished={surveyFinished}
          StartSurvey={StartSurvey}
          formPayload={formPayload}
          submitAnswer={submitAnswer}
          language={language}
          color={organizationInfo?.progress_bar}
          disabledNext={disableNext}
        />

        {/* {renderButtons(questionsList[currentQuestion])} */}
      </ButtonContainer>
    </SurveyContainer>
  );
};

export default AuditSurvey;

const SurveyContainer = styled.div`
  width: 100%;

  min-height: calc(var(--vh, 1vh) * 100);

  display: flex;

  flex-direction: column;

  background-color: #f8f9fa;

  position: relative;

  font-family: "Raleway", sans-serif;

  padding-top: ${(props) =>
    props.topPadding ? `${props.topPadding}px` : "50px"};

  @media (max-width: 768px) {
    height: 100%;

    padding-top: ${(props) =>
      props.topPadding ? `${props.topPadding}px` : "50px"};
  }
`;

const SurveyContent = styled.div`
  flex-grow: 1;

  display: flex;

  align-items: center;

  justify-content: center;

  position: relative;
`;

// ...

const ButtonContainer = styled.div`
  position: fixed;

  left: 0;

  right: 0;

  bottom: 0;

  display: flex;

  justify-content: space-between;

  padding: 1rem;

  background: #ffffff;

  border-top: 1px solid rgba(0, 0, 0, 0.06);

  z-index: 1000;
`;

const fadeIn = keyframes`

  from {

    opacity: 0;

    transform: translateY(-20px);

  }

  to {

    opacity: 1;

    transform: translateY(0);

  }

`;

// ...

const TopBar = styled.div`
  position: fixed;

  top: 0;

  left: 0;

  right: 0;

  background: #ffffff;

  z-index: 998;

  padding: 6px 10px;

  min-height: 50px;

  display: flex;

  align-items: center;

  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
`;

const ModuleContainer = styled.div`
  display: flex;

  align-items: center;

  justify-content: center;

  z-index: 3;

  min-height: ${(props) => `calc(${props.height}px - 130px)`};

  padding: 20px;

  padding-bottom: calc(100px + env(safe-area-inset-bottom));

  opacity: 0;

  animation: ${fadeIn} 1s ease-out forwards;

  animation-delay: ${({ delay }) => delay}s; // Use props to set delay

  @media (min-width: 768px) {
    min-height: ${(props) =>
      props.endScreen ? "100vh" : `calc(100vh - 90px)`};
  }
`;

const Back = styled.div`
  position: absolute;

  left: 28px;

  top: 20px;

  cursor: pointer;

  font-size: 20px;

  width: 50px;

  height: 50px;

  z-index: 10000;

  color: #2a3039;
`;
